(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlinx-serialization-kotlinx-serialization-core.js', './kotlin-kotlin-stdlib.js', './fixers-s2-s2-automate-s2-automate-dsl.js', './fixers-f2-f2-dsl-f2-dsl-cqrs.js', './boislocal-platform-platform-s2-referential-organizationType-organizationType-domain.js', './boislocal-platform-platform-infra-urlShortener-urlShortener-domain.js', './boislocal-platform-platform-infra-commons-commons-domain.js', './boislocal-platform-platform-s2-referential-realizationCertification-realizationCertification-domain.js', './boislocal-platform-platform-s2-ouvrage-ouvrage-domain.js', './boislocal-platform-platform-s2-referential-woodSpecies-woodSpecies-domain.js', './boislocal-platform-platform-s2-removalZone-removalZone-domain.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlinx-serialization-kotlinx-serialization-core.js'), require('./kotlin-kotlin-stdlib.js'), require('./fixers-s2-s2-automate-s2-automate-dsl.js'), require('./fixers-f2-f2-dsl-f2-dsl-cqrs.js'), require('./boislocal-platform-platform-s2-referential-organizationType-organizationType-domain.js'), require('./boislocal-platform-platform-infra-urlShortener-urlShortener-domain.js'), require('./boislocal-platform-platform-infra-commons-commons-domain.js'), require('./boislocal-platform-platform-s2-referential-realizationCertification-realizationCertification-domain.js'), require('./boislocal-platform-platform-s2-ouvrage-ouvrage-domain.js'), require('./boislocal-platform-platform-s2-referential-woodSpecies-woodSpecies-domain.js'), require('./boislocal-platform-platform-s2-removalZone-removalZone-domain.js'));
  else {
    if (typeof this['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-realization-realization-domain'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core' is loaded prior to 'boislocal-platform-platform-s2-realization-realization-domain'.");
    }
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-realization-realization-domain'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'boislocal-platform-platform-s2-realization-realization-domain'.");
    }
    if (typeof this['fixers-s2-s2-automate-s2-automate-dsl'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-realization-realization-domain'. Its dependency 'fixers-s2-s2-automate-s2-automate-dsl' was not found. Please, check whether 'fixers-s2-s2-automate-s2-automate-dsl' is loaded prior to 'boislocal-platform-platform-s2-realization-realization-domain'.");
    }
    if (typeof this['fixers-f2-f2-dsl-f2-dsl-cqrs'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-realization-realization-domain'. Its dependency 'fixers-f2-f2-dsl-f2-dsl-cqrs' was not found. Please, check whether 'fixers-f2-f2-dsl-f2-dsl-cqrs' is loaded prior to 'boislocal-platform-platform-s2-realization-realization-domain'.");
    }
    if (typeof this['boislocal-platform-platform-s2-referential-organizationType-organizationType-domain'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-realization-realization-domain'. Its dependency 'boislocal-platform-platform-s2-referential-organizationType-organizationType-domain' was not found. Please, check whether 'boislocal-platform-platform-s2-referential-organizationType-organizationType-domain' is loaded prior to 'boislocal-platform-platform-s2-realization-realization-domain'.");
    }
    if (typeof this['boislocal-platform-platform-infra-urlShortener-urlShortener-domain'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-realization-realization-domain'. Its dependency 'boislocal-platform-platform-infra-urlShortener-urlShortener-domain' was not found. Please, check whether 'boislocal-platform-platform-infra-urlShortener-urlShortener-domain' is loaded prior to 'boislocal-platform-platform-s2-realization-realization-domain'.");
    }
    if (typeof this['boislocal-platform-platform-infra-commons-commons-domain'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-realization-realization-domain'. Its dependency 'boislocal-platform-platform-infra-commons-commons-domain' was not found. Please, check whether 'boislocal-platform-platform-infra-commons-commons-domain' is loaded prior to 'boislocal-platform-platform-s2-realization-realization-domain'.");
    }
    if (typeof this['boislocal-platform-platform-s2-referential-realizationCertification-realizationCertification-domain'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-realization-realization-domain'. Its dependency 'boislocal-platform-platform-s2-referential-realizationCertification-realizationCertification-domain' was not found. Please, check whether 'boislocal-platform-platform-s2-referential-realizationCertification-realizationCertification-domain' is loaded prior to 'boislocal-platform-platform-s2-realization-realization-domain'.");
    }
    if (typeof this['boislocal-platform-platform-s2-ouvrage-ouvrage-domain'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-realization-realization-domain'. Its dependency 'boislocal-platform-platform-s2-ouvrage-ouvrage-domain' was not found. Please, check whether 'boislocal-platform-platform-s2-ouvrage-ouvrage-domain' is loaded prior to 'boislocal-platform-platform-s2-realization-realization-domain'.");
    }
    if (typeof this['boislocal-platform-platform-s2-referential-woodSpecies-woodSpecies-domain'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-realization-realization-domain'. Its dependency 'boislocal-platform-platform-s2-referential-woodSpecies-woodSpecies-domain' was not found. Please, check whether 'boislocal-platform-platform-s2-referential-woodSpecies-woodSpecies-domain' is loaded prior to 'boislocal-platform-platform-s2-realization-realization-domain'.");
    }
    if (typeof this['boislocal-platform-platform-s2-removalZone-removalZone-domain'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-realization-realization-domain'. Its dependency 'boislocal-platform-platform-s2-removalZone-removalZone-domain' was not found. Please, check whether 'boislocal-platform-platform-s2-removalZone-removalZone-domain' is loaded prior to 'boislocal-platform-platform-s2-realization-realization-domain'.");
    }
    root['boislocal-platform-platform-s2-realization-realization-domain'] = factory(typeof this['boislocal-platform-platform-s2-realization-realization-domain'] === 'undefined' ? {} : this['boislocal-platform-platform-s2-realization-realization-domain'], this['kotlinx-serialization-kotlinx-serialization-core'], this['kotlin-kotlin-stdlib'], this['fixers-s2-s2-automate-s2-automate-dsl'], this['fixers-f2-f2-dsl-f2-dsl-cqrs'], this['boislocal-platform-platform-s2-referential-organizationType-organizationType-domain'], this['boislocal-platform-platform-infra-urlShortener-urlShortener-domain'], this['boislocal-platform-platform-infra-commons-commons-domain'], this['boislocal-platform-platform-s2-referential-realizationCertification-realizationCertification-domain'], this['boislocal-platform-platform-s2-ouvrage-ouvrage-domain'], this['boislocal-platform-platform-s2-referential-woodSpecies-woodSpecies-domain'], this['boislocal-platform-platform-s2-removalZone-removalZone-domain']);
  }
}(this, function (_, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_kotlin, kotlin_io_komune_s2_s2_automate_dsl, kotlin_io_komune_f2_f2_dsl_cqrs, kotlin_org_boislocal_organizationType_domain, kotlin_org_boislocal_urlShortener_domain, kotlin_org_boislocal_commons_domain, kotlin_org_boislocal_realizationCertification_domain, kotlin_org_boislocal_ouvrage_domain, kotlin_org_boislocal_woodSpecies_domain, kotlin_org_boislocal_removalZone_domain) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var createSimpleEnumSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.c2;
  var LazyThreadSafetyMode_PUBLICATION_getInstance = kotlin_kotlin.$_$.i;
  var lazy = kotlin_kotlin.$_$.ge;
  var protoOf = kotlin_kotlin.$_$.fa;
  var SerializerFactory = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b2;
  var objectMeta = kotlin_kotlin.$_$.ea;
  var setMetadataFor = kotlin_kotlin.$_$.ga;
  var VOID = kotlin_kotlin.$_$.g;
  var THROW_IAE = kotlin_kotlin.$_$.ld;
  var Unit_instance = kotlin_kotlin.$_$.t4;
  var Enum = kotlin_kotlin.$_$.zc;
  var defineProp = kotlin_kotlin.$_$.b9;
  var S2State = kotlin_io_komune_s2_s2_automate_dsl.$_$.j;
  var classMeta = kotlin_kotlin.$_$.z8;
  var S2TransitionBuilder = kotlin_io_komune_s2_s2_automate_dsl.$_$.b;
  var toValue = kotlin_io_komune_s2_s2_automate_dsl.$_$.m;
  var toValue_0 = kotlin_io_komune_s2_s2_automate_dsl.$_$.n;
  var getKClass = kotlin_kotlin.$_$.f;
  var toValue_1 = kotlin_io_komune_s2_s2_automate_dsl.$_$.l;
  var S2Transition = kotlin_io_komune_s2_s2_automate_dsl.$_$.k;
  var S2SelfTransitionBuilder = kotlin_io_komune_s2_s2_automate_dsl.$_$.a;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.j5;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.k;
  var s2Sourcing = kotlin_io_komune_s2_s2_automate_dsl.$_$.c;
  var PluginGeneratedSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.z1;
  var StringSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.r;
  var UnknownFieldException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e;
  var THROW_CCE = kotlin_kotlin.$_$.kd;
  var typeParametersSerializers = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.u1;
  var GeneratedSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v1;
  var throwMissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e2;
  var objectCreate = kotlin_kotlin.$_$.da;
  var S2Role = kotlin_io_komune_s2_s2_automate_dsl.$_$.i;
  var S2Command = kotlin_io_komune_s2_s2_automate_dsl.$_$.g;
  var interfaceMeta = kotlin_kotlin.$_$.k9;
  var WithS2Id = kotlin_io_komune_s2_s2_automate_dsl.$_$.e;
  var Event = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.d;
  var getStringHashCode = kotlin_kotlin.$_$.i9;
  var hashCode = kotlin_kotlin.$_$.j9;
  var equals = kotlin_kotlin.$_$.c9;
  var $serializer_getInstance = kotlin_org_boislocal_organizationType_domain.$_$.a;
  var LongSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.q;
  var Long = kotlin_kotlin.$_$.ed;
  var S2InitCommand = kotlin_io_komune_s2_s2_automate_dsl.$_$.h;
  var $serializer_getInstance_0 = kotlin_org_boislocal_urlShortener_domain.$_$.a;
  var get_nullable = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v;
  var $serializer_getInstance_1 = kotlin_org_boislocal_commons_domain.$_$.i;
  var ArrayListSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.s1;
  var $serializer_getInstance_2 = kotlin_org_boislocal_realizationCertification_domain.$_$.a;
  var WithS2State = kotlin_io_komune_s2_s2_automate_dsl.$_$.f;
  var $serializer_getInstance_3 = kotlin_org_boislocal_commons_domain.$_$.k;
  var $serializer_getInstance_4 = kotlin_org_boislocal_ouvrage_domain.$_$.a;
  var $serializer_getInstance_5 = kotlin_org_boislocal_woodSpecies_domain.$_$.a;
  var $serializer_getInstance_6 = kotlin_org_boislocal_removalZone_domain.$_$.a;
  var emptyList = kotlin_kotlin.$_$.b6;
  var toString = kotlin_kotlin.$_$.le;
  var Query = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.e;
  var PageQueryDTO = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.a;
  var PageQueryResultDTO = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.b;
  //endregion
  //region block: pre-declaration
  setMetadataFor(Companion, 'Companion', objectMeta, VOID, [SerializerFactory]);
  setMetadataFor(RealizationState, 'RealizationState', classMeta, Enum, [Enum, S2State], VOID, VOID, {0: Companion_getInstance});
  setMetadataFor(S2, 'S2', objectMeta);
  setMetadataFor(UserRole, 'UserRole', classMeta, VOID, [S2Role], VOID, VOID, {0: $serializer_getInstance_7});
  setMetadataFor(User, 'User', objectMeta, UserRole);
  setMetadataFor(Companion_0, 'Companion', objectMeta);
  setMetadataFor($serializer, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(RealizationAssignMoeCommandDTO, 'RealizationAssignMoeCommandDTO', interfaceMeta, VOID, [S2Command]);
  setMetadataFor(RealizationAssignedMoeEventDTO, 'RealizationAssignedMoeEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(RealizationAssignMoeCommand, 'RealizationAssignMoeCommand', classMeta, VOID, [RealizationAssignMoeCommandDTO]);
  setMetadataFor(Companion_1, 'Companion', objectMeta);
  setMetadataFor($serializer_0, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(RealizationAssignedMoeEvent, 'RealizationAssignedMoeEvent', classMeta, VOID, [RealizationAssignedMoeEventDTO], VOID, VOID, {0: $serializer_getInstance_8});
  setMetadataFor(RealizationCreateCommandDTO, 'RealizationCreateCommandDTO', interfaceMeta, VOID, [S2InitCommand]);
  setMetadataFor(RealizationCreatedEventDTO, 'RealizationCreatedEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(RealizationCreateCommand, 'RealizationCreateCommand', classMeta, VOID, [RealizationCreateCommandDTO]);
  setMetadataFor(Companion_2, 'Companion', objectMeta);
  setMetadataFor($serializer_1, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(RealizationCreatedEvent, 'RealizationCreatedEvent', classMeta, VOID, [RealizationCreatedEventDTO], VOID, VOID, {0: $serializer_getInstance_9});
  setMetadataFor(RealizationDeleteCommandDTO, 'RealizationDeleteCommandDTO', interfaceMeta, VOID, [S2Command]);
  setMetadataFor(RealizationDeletedEventDTO, 'RealizationDeletedEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(Companion_3, 'Companion', objectMeta);
  setMetadataFor($serializer_2, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(RealizationDeleteCommand, 'RealizationDeleteCommand', classMeta, VOID, [RealizationDeleteCommandDTO], VOID, VOID, {0: $serializer_getInstance_10});
  setMetadataFor(Companion_4, 'Companion', objectMeta);
  setMetadataFor($serializer_3, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(RealizationDeletedEvent, 'RealizationDeletedEvent', classMeta, VOID, [RealizationDeletedEventDTO], VOID, VOID, {0: $serializer_getInstance_11});
  setMetadataFor(RealizationFinishCommandDTO, 'RealizationFinishCommandDTO', interfaceMeta, VOID, [S2Command]);
  setMetadataFor(RealizationFinishedEventDTO, 'RealizationFinishedEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(Companion_5, 'Companion', objectMeta);
  setMetadataFor($serializer_4, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(RealizationFinishCommand, 'RealizationFinishCommand', classMeta, VOID, [RealizationFinishCommandDTO], VOID, VOID, {0: $serializer_getInstance_12});
  setMetadataFor(Companion_6, 'Companion', objectMeta);
  setMetadataFor($serializer_5, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(RealizationFinishedEvent, 'RealizationFinishedEvent', classMeta, VOID, [RealizationFinishedEventDTO], VOID, VOID, {0: $serializer_getInstance_13});
  setMetadataFor(RealizationImportCommandDTO, 'RealizationImportCommandDTO', interfaceMeta, VOID, [S2InitCommand]);
  setMetadataFor(RealizationImportedEventDTO, 'RealizationImportedEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(Companion_7, 'Companion', objectMeta);
  setMetadataFor($serializer_6, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(RealizationImportCommand, 'RealizationImportCommand', classMeta, VOID, [RealizationImportCommandDTO], VOID, VOID, {0: $serializer_getInstance_14});
  setMetadataFor(Companion_8, 'Companion', objectMeta);
  setMetadataFor($serializer_7, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(RealizationImportedEvent, 'RealizationImportedEvent', classMeta, VOID, [RealizationImportedEventDTO], VOID, VOID, {0: $serializer_getInstance_15});
  setMetadataFor(RealizationRemoveMoeCommandDTO, 'RealizationRemoveMoeCommandDTO', interfaceMeta, VOID, [S2Command]);
  setMetadataFor(RealizationRemovedMoeEventDTO, 'RealizationRemovedMoeEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(RealizationRemoveMoeCommand, 'RealizationRemoveMoeCommand', classMeta, VOID, [RealizationRemoveMoeCommandDTO]);
  setMetadataFor(Companion_9, 'Companion', objectMeta);
  setMetadataFor($serializer_8, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(RealizationRemovedMoeEvent, 'RealizationRemovedMoeEvent', classMeta, VOID, [RealizationRemovedMoeEventDTO], VOID, VOID, {0: $serializer_getInstance_16});
  setMetadataFor(RealizationUnlockCommandDTO, 'RealizationUnlockCommandDTO', interfaceMeta, VOID, [S2Command]);
  setMetadataFor(RealizationUnlockedEventDTO, 'RealizationUnlockedEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(Companion_10, 'Companion', objectMeta);
  setMetadataFor($serializer_9, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(RealizationUnlockCommand, 'RealizationUnlockCommand', classMeta, VOID, [RealizationUnlockCommandDTO], VOID, VOID, {0: $serializer_getInstance_17});
  setMetadataFor(Companion_11, 'Companion', objectMeta);
  setMetadataFor($serializer_10, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(RealizationUnlockedEvent, 'RealizationUnlockedEvent', classMeta, VOID, [RealizationUnlockedEventDTO], VOID, VOID, {0: $serializer_getInstance_18});
  setMetadataFor(RealizationUpdateCommandDTO, 'RealizationUpdateCommandDTO', interfaceMeta, VOID, [S2Command]);
  setMetadataFor(RealizationUpdatedEventDTO, 'RealizationUpdatedEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(RealizationUpdateCommand, 'RealizationUpdateCommand', classMeta, VOID, [RealizationUpdateCommandDTO]);
  setMetadataFor(Companion_12, 'Companion', objectMeta);
  setMetadataFor($serializer_11, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(RealizationUpdatedEvent, 'RealizationUpdatedEvent', classMeta, VOID, [RealizationUpdatedEventDTO], VOID, VOID, {0: $serializer_getInstance_19});
  setMetadataFor(RealizationCertificationIdLinkDTO, 'RealizationCertificationIdLinkDTO', interfaceMeta);
  setMetadataFor(RealizationCertificationLinkDTO, 'RealizationCertificationLinkDTO', interfaceMeta);
  setMetadataFor($serializer_12, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(RealizationCertificationLink, 'RealizationCertificationLink', classMeta, VOID, [RealizationCertificationLinkDTO], VOID, VOID, {0: $serializer_getInstance_20});
  setMetadataFor($serializer_13, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(RealizationCertificationIdLink, 'RealizationCertificationIdLink', classMeta, VOID, [RealizationCertificationIdLinkDTO], VOID, VOID, {0: $serializer_getInstance_21});
  setMetadataFor(RealizationModelDTO, 'RealizationModelDTO', interfaceMeta, VOID, [WithS2State, WithS2Id]);
  setMetadataFor(TransformationActorDTO, 'TransformationActorDTO', interfaceMeta);
  setMetadataFor(Companion_13, 'Companion', objectMeta);
  setMetadataFor($serializer_14, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(RealizationModel, 'RealizationModel', classMeta, VOID, [RealizationModelDTO], VOID, VOID, {0: $serializer_getInstance_22});
  setMetadataFor(Companion_14, 'Companion', objectMeta);
  setMetadataFor($serializer_15, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(TransformationActor, 'TransformationActor', classMeta, VOID, [TransformationActorDTO], VOID, VOID, {0: $serializer_getInstance_23});
  setMetadataFor(RealizationRefDTO, 'RealizationRefDTO', interfaceMeta);
  setMetadataFor(RealizationModelGetQueryDTO, 'RealizationModelGetQueryDTO', interfaceMeta, VOID, [Query]);
  setMetadataFor(RealizationModelGetResponseDTO, 'RealizationModelGetResponseDTO', interfaceMeta);
  setMetadataFor(RealizationModelPageFiltersDTO, 'RealizationModelPageFiltersDTO', interfaceMeta);
  setMetadataFor(RealizationModelPageQueryDTO, 'RealizationModelPageQueryDTO', interfaceMeta, VOID, [PageQueryDTO]);
  setMetadataFor(RealizationModelPageResponseDTO, 'RealizationModelPageResponseDTO', interfaceMeta, VOID, [PageQueryResultDTO]);
  //endregion
  function _get_$cachedSerializer__te6jhj($this) {
    return $this.o30_1.f2();
  }
  function RealizationState$Companion$_anonymous__3jm0mc() {
    return createSimpleEnumSerializer('org.boislocal.platform.s2.realization.domain.automate.RealizationState', values());
  }
  var RealizationState_Exists_instance;
  var RealizationState_Deleted_instance;
  var RealizationState_Finished_instance;
  function Companion() {
    Companion_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.o30_1 = lazy(tmp_0, RealizationState$Companion$_anonymous__3jm0mc);
  }
  protoOf(Companion).x14 = function () {
    return _get_$cachedSerializer__te6jhj(this);
  };
  protoOf(Companion).hu = function (typeParamsSerializers) {
    return this.x14();
  };
  var Companion_instance;
  function Companion_getInstance() {
    RealizationState_initEntries();
    if (Companion_instance == null)
      new Companion();
    return Companion_instance;
  }
  function values() {
    return [RealizationState_Exists_getInstance(), RealizationState_Deleted_getInstance(), RealizationState_Finished_getInstance()];
  }
  function valueOf(value) {
    switch (value) {
      case 'Exists':
        return RealizationState_Exists_getInstance();
      case 'Deleted':
        return RealizationState_Deleted_getInstance();
      case 'Finished':
        return RealizationState_Finished_getInstance();
      default:
        RealizationState_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var RealizationState_entriesInitialized;
  function RealizationState_initEntries() {
    if (RealizationState_entriesInitialized)
      return Unit_instance;
    RealizationState_entriesInitialized = true;
    RealizationState_Exists_instance = new RealizationState('Exists', 0, 0);
    RealizationState_Deleted_instance = new RealizationState('Deleted', 1, 1);
    RealizationState_Finished_instance = new RealizationState('Finished', 2, 2);
    Companion_getInstance();
  }
  function RealizationState(name, ordinal, position) {
    Enum.call(this, name, ordinal);
    this.r30_1 = position;
  }
  protoOf(RealizationState).y2c = function (_set____db54di) {
    this.r30_1 = _set____db54di;
  };
  protoOf(RealizationState).jr = function () {
    return this.r30_1;
  };
  function S2$realizationAutomate$lambda($this$s2Sourcing) {
    $this$s2Sourcing.j27_1 = 'Realization';
    // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.transaction' call
    var builder = new S2TransitionBuilder();
    // Inline function 'org.boislocal.platform.s2.realization.domain.automate.S2.realizationAutomate.<anonymous>.<anonymous>' call
    builder.o27_1 = RealizationState_Exists_getInstance();
    builder.p27_1 = User_getInstance();
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver = builder.m27_1;
    var tmp = tmp0_safe_receiver == null ? null : toValue(tmp0_safe_receiver);
    var tmp_0 = toValue(builder.c24());
    var tmp_1 = toValue_0(builder.d24());
    var tmp_2 = toValue_1(getKClass(RealizationImportCommand));
    var tmp1_elvis_lhs = builder.q27_1;
    var this_0 = new S2Transition(tmp, tmp_0, tmp_1, tmp_2, toValue_1(tmp1_elvis_lhs == null ? getKClass(RealizationImportedEvent) : tmp1_elvis_lhs));
    // Inline function 'kotlin.contracts.contract' call
    $this$s2Sourcing.l27_1.r(this_0);
    // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.transaction' call
    var builder_0 = new S2TransitionBuilder();
    // Inline function 'org.boislocal.platform.s2.realization.domain.automate.S2.realizationAutomate.<anonymous>.<anonymous>' call
    builder_0.o27_1 = RealizationState_Finished_getInstance();
    builder_0.p27_1 = User_getInstance();
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver_0 = builder_0.m27_1;
    var tmp_3 = tmp0_safe_receiver_0 == null ? null : toValue(tmp0_safe_receiver_0);
    var tmp_4 = toValue(builder_0.c24());
    var tmp_5 = toValue_0(builder_0.d24());
    var tmp_6 = toValue_1(getKClass(RealizationImportCommand));
    var tmp1_elvis_lhs_0 = builder_0.q27_1;
    var this_1 = new S2Transition(tmp_3, tmp_4, tmp_5, tmp_6, toValue_1(tmp1_elvis_lhs_0 == null ? getKClass(RealizationImportedEvent) : tmp1_elvis_lhs_0));
    // Inline function 'kotlin.contracts.contract' call
    $this$s2Sourcing.l27_1.r(this_1);
    // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.transaction' call
    var builder_1 = new S2TransitionBuilder();
    // Inline function 'org.boislocal.platform.s2.realization.domain.automate.S2.realizationAutomate.<anonymous>.<anonymous>' call
    builder_1.o27_1 = RealizationState_Deleted_getInstance();
    builder_1.p27_1 = User_getInstance();
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver_1 = builder_1.m27_1;
    var tmp_7 = tmp0_safe_receiver_1 == null ? null : toValue(tmp0_safe_receiver_1);
    var tmp_8 = toValue(builder_1.c24());
    var tmp_9 = toValue_0(builder_1.d24());
    var tmp_10 = toValue_1(getKClass(RealizationImportCommand));
    var tmp1_elvis_lhs_1 = builder_1.q27_1;
    var this_2 = new S2Transition(tmp_7, tmp_8, tmp_9, tmp_10, toValue_1(tmp1_elvis_lhs_1 == null ? getKClass(RealizationImportedEvent) : tmp1_elvis_lhs_1));
    // Inline function 'kotlin.contracts.contract' call
    $this$s2Sourcing.l27_1.r(this_2);
    // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.transaction' call
    var builder_2 = new S2TransitionBuilder();
    // Inline function 'org.boislocal.platform.s2.realization.domain.automate.S2.realizationAutomate.<anonymous>.<anonymous>' call
    builder_2.o27_1 = RealizationState_Exists_getInstance();
    builder_2.p27_1 = User_getInstance();
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver_2 = builder_2.m27_1;
    var tmp_11 = tmp0_safe_receiver_2 == null ? null : toValue(tmp0_safe_receiver_2);
    var tmp_12 = toValue(builder_2.c24());
    var tmp_13 = toValue_0(builder_2.d24());
    var tmp_14 = toValue_1(getKClass(RealizationCreateCommand));
    var tmp1_elvis_lhs_2 = builder_2.q27_1;
    var this_3 = new S2Transition(tmp_11, tmp_12, tmp_13, tmp_14, toValue_1(tmp1_elvis_lhs_2 == null ? getKClass(RealizationCreatedEvent) : tmp1_elvis_lhs_2));
    // Inline function 'kotlin.contracts.contract' call
    $this$s2Sourcing.l27_1.r(this_3);
    // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.selfTransaction' call
    var builder_3 = new S2SelfTransitionBuilder();
    // Inline function 'org.boislocal.platform.s2.realization.domain.automate.S2.realizationAutomate.<anonymous>.<anonymous>' call
    // Inline function 'kotlin.collections.plusAssign' call
    var this_4 = builder_3.r27_1;
    var element = RealizationState_Exists_getInstance();
    this_4.r(element);
    builder_3.s27_1 = User_getInstance();
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.map' call
    var this_5 = builder_3.r27_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_5, 10));
    var tmp0_iterator = this_5.u();
    while (tmp0_iterator.v()) {
      var item = tmp0_iterator.w();
      // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.selfTransaction.<anonymous>' call
      var tmp_15 = toValue(item);
      var tmp_16 = toValue(item);
      var tmp_17 = toValue_0(builder_3.d24());
      var tmp_18 = toValue_1(getKClass(RealizationUpdateCommand));
      var tmp0_elvis_lhs = builder_3.t27_1;
      var tmp$ret$8 = new S2Transition(tmp_15, tmp_16, tmp_17, tmp_18, toValue_1(tmp0_elvis_lhs == null ? getKClass(RealizationUpdatedEvent) : tmp0_elvis_lhs));
      destination.r(tmp$ret$8);
    }
    var tmp3_forEach_receiver = $this$s2Sourcing.l27_1;
    var tmp0_iterator_0 = destination.u();
    while (tmp0_iterator_0.v()) {
      var element_0 = tmp0_iterator_0.w();
      invoke$add(tmp3_forEach_receiver, element_0);
    }
    // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.selfTransaction' call
    var builder_4 = new S2SelfTransitionBuilder();
    // Inline function 'org.boislocal.platform.s2.realization.domain.automate.S2.realizationAutomate.<anonymous>.<anonymous>' call
    // Inline function 'kotlin.collections.plusAssign' call
    var this_6 = builder_4.r27_1;
    var element_1 = RealizationState_Exists_getInstance();
    this_6.r(element_1);
    builder_4.s27_1 = User_getInstance();
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.map' call
    var this_7 = builder_4.r27_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_7, 10));
    var tmp0_iterator_1 = this_7.u();
    while (tmp0_iterator_1.v()) {
      var item_0 = tmp0_iterator_1.w();
      // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.selfTransaction.<anonymous>' call
      var tmp_19 = toValue(item_0);
      var tmp_20 = toValue(item_0);
      var tmp_21 = toValue_0(builder_4.d24());
      var tmp_22 = toValue_1(getKClass(RealizationAssignMoeCommand));
      var tmp0_elvis_lhs_0 = builder_4.t27_1;
      var tmp$ret$12 = new S2Transition(tmp_19, tmp_20, tmp_21, tmp_22, toValue_1(tmp0_elvis_lhs_0 == null ? getKClass(RealizationAssignedMoeEvent) : tmp0_elvis_lhs_0));
      destination_0.r(tmp$ret$12);
    }
    var tmp3_forEach_receiver_0 = $this$s2Sourcing.l27_1;
    var tmp0_iterator_2 = destination_0.u();
    while (tmp0_iterator_2.v()) {
      var element_2 = tmp0_iterator_2.w();
      invoke$add_0(tmp3_forEach_receiver_0, element_2);
    }
    // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.selfTransaction' call
    var builder_5 = new S2SelfTransitionBuilder();
    // Inline function 'org.boislocal.platform.s2.realization.domain.automate.S2.realizationAutomate.<anonymous>.<anonymous>' call
    // Inline function 'kotlin.collections.plusAssign' call
    var this_8 = builder_5.r27_1;
    var element_3 = RealizationState_Exists_getInstance();
    this_8.r(element_3);
    builder_5.s27_1 = User_getInstance();
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.map' call
    var this_9 = builder_5.r27_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(this_9, 10));
    var tmp0_iterator_3 = this_9.u();
    while (tmp0_iterator_3.v()) {
      var item_1 = tmp0_iterator_3.w();
      // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.selfTransaction.<anonymous>' call
      var tmp_23 = toValue(item_1);
      var tmp_24 = toValue(item_1);
      var tmp_25 = toValue_0(builder_5.d24());
      var tmp_26 = toValue_1(getKClass(RealizationRemoveMoeCommand));
      var tmp0_elvis_lhs_1 = builder_5.t27_1;
      var tmp$ret$16 = new S2Transition(tmp_23, tmp_24, tmp_25, tmp_26, toValue_1(tmp0_elvis_lhs_1 == null ? getKClass(RealizationRemovedMoeEvent) : tmp0_elvis_lhs_1));
      destination_1.r(tmp$ret$16);
    }
    var tmp3_forEach_receiver_1 = $this$s2Sourcing.l27_1;
    var tmp0_iterator_4 = destination_1.u();
    while (tmp0_iterator_4.v()) {
      var element_4 = tmp0_iterator_4.w();
      invoke$add_1(tmp3_forEach_receiver_1, element_4);
    }
    // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.transaction' call
    var builder_6 = new S2TransitionBuilder();
    // Inline function 'org.boislocal.platform.s2.realization.domain.automate.S2.realizationAutomate.<anonymous>.<anonymous>' call
    builder_6.m27_1 = RealizationState_Exists_getInstance();
    builder_6.o27_1 = RealizationState_Deleted_getInstance();
    builder_6.p27_1 = User_getInstance();
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver_3 = builder_6.m27_1;
    var tmp_27 = tmp0_safe_receiver_3 == null ? null : toValue(tmp0_safe_receiver_3);
    var tmp_28 = toValue(builder_6.c24());
    var tmp_29 = toValue_0(builder_6.d24());
    var tmp_30 = toValue_1(getKClass(RealizationDeleteCommand));
    var tmp1_elvis_lhs_3 = builder_6.q27_1;
    var this_10 = new S2Transition(tmp_27, tmp_28, tmp_29, tmp_30, toValue_1(tmp1_elvis_lhs_3 == null ? getKClass(RealizationDeletedEvent) : tmp1_elvis_lhs_3));
    // Inline function 'kotlin.contracts.contract' call
    $this$s2Sourcing.l27_1.r(this_10);
    // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.transaction' call
    var builder_7 = new S2TransitionBuilder();
    // Inline function 'org.boislocal.platform.s2.realization.domain.automate.S2.realizationAutomate.<anonymous>.<anonymous>' call
    builder_7.m27_1 = RealizationState_Exists_getInstance();
    builder_7.o27_1 = RealizationState_Finished_getInstance();
    builder_7.p27_1 = User_getInstance();
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver_4 = builder_7.m27_1;
    var tmp_31 = tmp0_safe_receiver_4 == null ? null : toValue(tmp0_safe_receiver_4);
    var tmp_32 = toValue(builder_7.c24());
    var tmp_33 = toValue_0(builder_7.d24());
    var tmp_34 = toValue_1(getKClass(RealizationFinishCommand));
    var tmp1_elvis_lhs_4 = builder_7.q27_1;
    var this_11 = new S2Transition(tmp_31, tmp_32, tmp_33, tmp_34, toValue_1(tmp1_elvis_lhs_4 == null ? getKClass(RealizationFinishedEvent) : tmp1_elvis_lhs_4));
    // Inline function 'kotlin.contracts.contract' call
    $this$s2Sourcing.l27_1.r(this_11);
    // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.transaction' call
    var builder_8 = new S2TransitionBuilder();
    // Inline function 'org.boislocal.platform.s2.realization.domain.automate.S2.realizationAutomate.<anonymous>.<anonymous>' call
    builder_8.m27_1 = RealizationState_Finished_getInstance();
    builder_8.o27_1 = RealizationState_Exists_getInstance();
    builder_8.p27_1 = User_getInstance();
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver_5 = builder_8.m27_1;
    var tmp_35 = tmp0_safe_receiver_5 == null ? null : toValue(tmp0_safe_receiver_5);
    var tmp_36 = toValue(builder_8.c24());
    var tmp_37 = toValue_0(builder_8.d24());
    var tmp_38 = toValue_1(getKClass(RealizationUnlockCommand));
    var tmp1_elvis_lhs_5 = builder_8.q27_1;
    var this_12 = new S2Transition(tmp_35, tmp_36, tmp_37, tmp_38, toValue_1(tmp1_elvis_lhs_5 == null ? getKClass(RealizationUnlockedEvent) : tmp1_elvis_lhs_5));
    // Inline function 'kotlin.contracts.contract' call
    $this$s2Sourcing.l27_1.r(this_12);
    return Unit_instance;
  }
  function invoke$add(receiver, p0) {
    receiver.r(p0);
  }
  function invoke$add_0(receiver, p0) {
    receiver.r(p0);
  }
  function invoke$add_1(receiver, p0) {
    receiver.r(p0);
  }
  function S2() {
    S2_instance = this;
    var tmp = this;
    tmp.s30_1 = s2Sourcing(S2$realizationAutomate$lambda);
  }
  var S2_instance;
  function S2_getInstance() {
    if (S2_instance == null)
      new S2();
    return S2_instance;
  }
  function User() {
    User_instance = this;
    UserRole.call(this, 'User');
  }
  var User_instance;
  function User_getInstance() {
    if (User_instance == null)
      new User();
    return User_instance;
  }
  function Companion_0() {
  }
  var Companion_instance_0;
  function Companion_getInstance_0() {
    return Companion_instance_0;
  }
  function $serializer() {
    $serializer_instance = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.realization.domain.automate.UserRole', this, 1);
    tmp0_serialDesc.ht('name', false);
    this.u30_1 = tmp0_serialDesc;
  }
  protoOf($serializer).ii = function () {
    return this.u30_1;
  };
  protoOf($serializer).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  protoOf($serializer).ki = function (decoder) {
    var tmp0_desc = this.u30_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.ul(tmp0_desc);
    if (tmp5_input.km()) {
      tmp4_local0 = tmp5_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.vl(tmp0_desc);
    return UserRole_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer).v30 = function (encoder, value) {
    var tmp0_desc = this.u30_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.h9());
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer).ji = function (encoder, value) {
    return this.v30(encoder, value instanceof UserRole ? value : THROW_CCE());
  };
  var $serializer_instance;
  function $serializer_getInstance_7() {
    if ($serializer_instance == null)
      new $serializer();
    return $serializer_instance;
  }
  function UserRole_init_$Init$(seen1, name, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance_7().u30_1);
    }
    $this.t30_1 = name;
    return $this;
  }
  function UserRole_init_$Create$(seen1, name, serializationConstructorMarker) {
    return UserRole_init_$Init$(seen1, name, serializationConstructorMarker, objectCreate(protoOf(UserRole)));
  }
  function UserRole(name) {
    this.t30_1 = name;
  }
  protoOf(UserRole).h9 = function () {
    return this.t30_1;
  };
  protoOf(UserRole).toString = function () {
    return this.h9();
  };
  function RealizationState_Exists_getInstance() {
    RealizationState_initEntries();
    return RealizationState_Exists_instance;
  }
  function RealizationState_Deleted_getInstance() {
    RealizationState_initEntries();
    return RealizationState_Deleted_instance;
  }
  function RealizationState_Finished_getInstance() {
    RealizationState_initEntries();
    return RealizationState_Finished_instance;
  }
  function RealizationAssignMoeCommandDTO() {
  }
  function RealizationAssignedMoeEventDTO() {
  }
  function RealizationAssignMoeCommand(id, organization, organizationName, organizationType, siret) {
    this.z30_1 = id;
    this.a31_1 = organization;
    this.b31_1 = organizationName;
    this.c31_1 = organizationType;
    this.d31_1 = siret;
  }
  protoOf(RealizationAssignMoeCommand).k1y = function () {
    return this.z30_1;
  };
  protoOf(RealizationAssignMoeCommand).c2p = function () {
    return this.a31_1;
  };
  protoOf(RealizationAssignMoeCommand).w30 = function () {
    return this.b31_1;
  };
  protoOf(RealizationAssignMoeCommand).x30 = function () {
    return this.c31_1;
  };
  protoOf(RealizationAssignMoeCommand).y30 = function () {
    return this.d31_1;
  };
  protoOf(RealizationAssignMoeCommand).toString = function () {
    return 'RealizationAssignMoeCommand(id=' + this.z30_1 + ', organization=' + this.a31_1 + ', organizationName=' + this.b31_1 + ', organizationType=' + this.c31_1 + ', siret=' + this.d31_1 + ')';
  };
  protoOf(RealizationAssignMoeCommand).hashCode = function () {
    var result = getStringHashCode(this.z30_1);
    result = imul(result, 31) + (this.a31_1 == null ? 0 : hashCode(this.a31_1)) | 0;
    result = imul(result, 31) + (this.b31_1 == null ? 0 : getStringHashCode(this.b31_1)) | 0;
    result = imul(result, 31) + (this.c31_1 == null ? 0 : hashCode(this.c31_1)) | 0;
    result = imul(result, 31) + (this.d31_1 == null ? 0 : getStringHashCode(this.d31_1)) | 0;
    return result;
  };
  protoOf(RealizationAssignMoeCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RealizationAssignMoeCommand))
      return false;
    var tmp0_other_with_cast = other instanceof RealizationAssignMoeCommand ? other : THROW_CCE();
    if (!(this.z30_1 === tmp0_other_with_cast.z30_1))
      return false;
    if (!equals(this.a31_1, tmp0_other_with_cast.a31_1))
      return false;
    if (!(this.b31_1 == tmp0_other_with_cast.b31_1))
      return false;
    if (!equals(this.c31_1, tmp0_other_with_cast.c31_1))
      return false;
    if (!(this.d31_1 == tmp0_other_with_cast.d31_1))
      return false;
    return true;
  };
  function Companion_1() {
    Companion_instance_1 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.e31_1 = [null, Companion_getInstance().x14(), null, null];
  }
  var Companion_instance_1;
  function Companion_getInstance_1() {
    if (Companion_instance_1 == null)
      new Companion_1();
    return Companion_instance_1;
  }
  function $serializer_0() {
    $serializer_instance_0 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RealizationAssignedMoeEvent', this, 4);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('status', false);
    tmp0_serialDesc.ht('organization', false);
    tmp0_serialDesc.ht('time', false);
    this.f31_1 = tmp0_serialDesc;
  }
  protoOf($serializer_0).ii = function () {
    return this.f31_1;
  };
  protoOf($serializer_0).wt = function () {
    var tmp0_cached = Companion_getInstance_1().e31_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), tmp0_cached[1], $serializer_getInstance(), LongSerializer_getInstance()];
  };
  protoOf($serializer_0).ki = function (decoder) {
    var tmp0_desc = this.f31_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = new Long(0, 0);
    var tmp8_input = decoder.ul(tmp0_desc);
    var tmp9_cached = Companion_getInstance_1().e31_1;
    if (tmp8_input.km()) {
      tmp4_local0 = tmp8_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.gm(tmp0_desc, 1, tmp9_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.gm(tmp0_desc, 2, $serializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.am(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.gm(tmp0_desc, 1, tmp9_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.gm(tmp0_desc, 2, $serializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.am(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.vl(tmp0_desc);
    return RealizationAssignedMoeEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_0).g31 = function (encoder, value) {
    var tmp0_desc = this.f31_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    var tmp2_cached = Companion_getInstance_1().e31_1;
    tmp1_output.jn(tmp0_desc, 0, value.h31_1);
    tmp1_output.ln(tmp0_desc, 1, tmp2_cached[1], value.i31_1);
    tmp1_output.ln(tmp0_desc, 2, $serializer_getInstance(), value.j31_1);
    tmp1_output.fn(tmp0_desc, 3, value.k31_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_0).ji = function (encoder, value) {
    return this.g31(encoder, value instanceof RealizationAssignedMoeEvent ? value : THROW_CCE());
  };
  var $serializer_instance_0;
  function $serializer_getInstance_8() {
    if ($serializer_instance_0 == null)
      new $serializer_0();
    return $serializer_instance_0;
  }
  function RealizationAssignedMoeEvent_init_$Init$(seen1, id, status, organization, time, serializationConstructorMarker, $this) {
    if (!(15 === (15 & seen1))) {
      throwMissingFieldException(seen1, 15, $serializer_getInstance_8().f31_1);
    }
    $this.h31_1 = id;
    $this.i31_1 = status;
    $this.j31_1 = organization;
    $this.k31_1 = time;
    return $this;
  }
  function RealizationAssignedMoeEvent_init_$Create$(seen1, id, status, organization, time, serializationConstructorMarker) {
    return RealizationAssignedMoeEvent_init_$Init$(seen1, id, status, organization, time, serializationConstructorMarker, objectCreate(protoOf(RealizationAssignedMoeEvent)));
  }
  function RealizationAssignedMoeEvent(id, status, organization, time) {
    Companion_getInstance_1();
    this.h31_1 = id;
    this.i31_1 = status;
    this.j31_1 = organization;
    this.k31_1 = time;
  }
  protoOf(RealizationAssignedMoeEvent).k1y = function () {
    return this.h31_1;
  };
  protoOf(RealizationAssignedMoeEvent).y2f = function () {
    return this.i31_1;
  };
  protoOf(RealizationAssignedMoeEvent).c2p = function () {
    return this.j31_1;
  };
  protoOf(RealizationAssignedMoeEvent).g2c = function () {
    return this.k31_1;
  };
  protoOf(RealizationAssignedMoeEvent).s2Id = function () {
    return this.h31_1;
  };
  protoOf(RealizationAssignedMoeEvent).toString = function () {
    return 'RealizationAssignedMoeEvent(id=' + this.h31_1 + ', status=' + this.i31_1 + ', organization=' + this.j31_1 + ', time=' + this.k31_1.toString() + ')';
  };
  protoOf(RealizationAssignedMoeEvent).hashCode = function () {
    var result = getStringHashCode(this.h31_1);
    result = imul(result, 31) + this.i31_1.hashCode() | 0;
    result = imul(result, 31) + this.j31_1.hashCode() | 0;
    result = imul(result, 31) + this.k31_1.hashCode() | 0;
    return result;
  };
  protoOf(RealizationAssignedMoeEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RealizationAssignedMoeEvent))
      return false;
    var tmp0_other_with_cast = other instanceof RealizationAssignedMoeEvent ? other : THROW_CCE();
    if (!(this.h31_1 === tmp0_other_with_cast.h31_1))
      return false;
    if (!this.i31_1.equals(tmp0_other_with_cast.i31_1))
      return false;
    if (!this.j31_1.equals(tmp0_other_with_cast.j31_1))
      return false;
    if (!this.k31_1.equals(tmp0_other_with_cast.k31_1))
      return false;
    return true;
  };
  function RealizationCreateCommandDTO() {
  }
  function RealizationCreatedEventDTO() {
  }
  function RealizationCreateCommand(name, coordinates, redirectPath, artIndex) {
    this.n31_1 = name;
    this.o31_1 = coordinates;
    this.p31_1 = redirectPath;
    this.q31_1 = artIndex;
  }
  protoOf(RealizationCreateCommand).h9 = function () {
    return this.n31_1;
  };
  protoOf(RealizationCreateCommand).l31 = function () {
    return this.o31_1;
  };
  protoOf(RealizationCreateCommand).h2c = function () {
    return this.p31_1;
  };
  protoOf(RealizationCreateCommand).m31 = function () {
    return this.q31_1;
  };
  protoOf(RealizationCreateCommand).toString = function () {
    return 'RealizationCreateCommand(name=' + this.n31_1 + ', coordinates=' + this.o31_1 + ', redirectPath=' + this.p31_1 + ', artIndex=' + this.q31_1 + ')';
  };
  protoOf(RealizationCreateCommand).hashCode = function () {
    var result = getStringHashCode(this.n31_1);
    result = imul(result, 31) + (this.o31_1 == null ? 0 : this.o31_1.hashCode()) | 0;
    result = imul(result, 31) + (this.p31_1 == null ? 0 : getStringHashCode(this.p31_1)) | 0;
    result = imul(result, 31) + (this.q31_1 == null ? 0 : getStringHashCode(this.q31_1)) | 0;
    return result;
  };
  protoOf(RealizationCreateCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RealizationCreateCommand))
      return false;
    var tmp0_other_with_cast = other instanceof RealizationCreateCommand ? other : THROW_CCE();
    if (!(this.n31_1 === tmp0_other_with_cast.n31_1))
      return false;
    if (!equals(this.o31_1, tmp0_other_with_cast.o31_1))
      return false;
    if (!(this.p31_1 == tmp0_other_with_cast.p31_1))
      return false;
    if (!(this.q31_1 == tmp0_other_with_cast.q31_1))
      return false;
    return true;
  };
  function Companion_2() {
    Companion_instance_2 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.r31_1 = [null, Companion_getInstance().x14(), null, null, null, null, null];
  }
  var Companion_instance_2;
  function Companion_getInstance_2() {
    if (Companion_instance_2 == null)
      new Companion_2();
    return Companion_instance_2;
  }
  function $serializer_1() {
    $serializer_instance_1 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RealizationCreatedEvent', this, 7);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('status', false);
    tmp0_serialDesc.ht('name', false);
    tmp0_serialDesc.ht('qrcode', false);
    tmp0_serialDesc.ht('coordinates', false);
    tmp0_serialDesc.ht('artIndex', false);
    tmp0_serialDesc.ht('time', false);
    this.s31_1 = tmp0_serialDesc;
  }
  protoOf($serializer_1).ii = function () {
    return this.s31_1;
  };
  protoOf($serializer_1).wt = function () {
    var tmp0_cached = Companion_getInstance_2().r31_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), tmp0_cached[1], StringSerializer_getInstance(), get_nullable($serializer_getInstance_0()), get_nullable($serializer_getInstance_1()), get_nullable(StringSerializer_getInstance()), LongSerializer_getInstance()];
  };
  protoOf($serializer_1).ki = function (decoder) {
    var tmp0_desc = this.s31_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = new Long(0, 0);
    var tmp11_input = decoder.ul(tmp0_desc);
    var tmp12_cached = Companion_getInstance_2().r31_1;
    if (tmp11_input.km()) {
      tmp4_local0 = tmp11_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp11_input.gm(tmp0_desc, 1, tmp12_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp11_input.em(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp11_input.im(tmp0_desc, 3, $serializer_getInstance_0(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp11_input.im(tmp0_desc, 4, $serializer_getInstance_1(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp11_input.im(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp11_input.am(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp11_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp11_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp11_input.gm(tmp0_desc, 1, tmp12_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp11_input.em(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp11_input.im(tmp0_desc, 3, $serializer_getInstance_0(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp11_input.im(tmp0_desc, 4, $serializer_getInstance_1(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp11_input.im(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp11_input.am(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp11_input.vl(tmp0_desc);
    return RealizationCreatedEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
  };
  protoOf($serializer_1).t31 = function (encoder, value) {
    var tmp0_desc = this.s31_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    var tmp2_cached = Companion_getInstance_2().r31_1;
    tmp1_output.jn(tmp0_desc, 0, value.u31_1);
    tmp1_output.ln(tmp0_desc, 1, tmp2_cached[1], value.v31_1);
    tmp1_output.jn(tmp0_desc, 2, value.w31_1);
    tmp1_output.nn(tmp0_desc, 3, $serializer_getInstance_0(), value.x31_1);
    tmp1_output.nn(tmp0_desc, 4, $serializer_getInstance_1(), value.y31_1);
    tmp1_output.nn(tmp0_desc, 5, StringSerializer_getInstance(), value.z31_1);
    tmp1_output.fn(tmp0_desc, 6, value.a32_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_1).ji = function (encoder, value) {
    return this.t31(encoder, value instanceof RealizationCreatedEvent ? value : THROW_CCE());
  };
  var $serializer_instance_1;
  function $serializer_getInstance_9() {
    if ($serializer_instance_1 == null)
      new $serializer_1();
    return $serializer_instance_1;
  }
  function RealizationCreatedEvent_init_$Init$(seen1, id, status, name, qrcode, coordinates, artIndex, time, serializationConstructorMarker, $this) {
    if (!(127 === (127 & seen1))) {
      throwMissingFieldException(seen1, 127, $serializer_getInstance_9().s31_1);
    }
    $this.u31_1 = id;
    $this.v31_1 = status;
    $this.w31_1 = name;
    $this.x31_1 = qrcode;
    $this.y31_1 = coordinates;
    $this.z31_1 = artIndex;
    $this.a32_1 = time;
    return $this;
  }
  function RealizationCreatedEvent_init_$Create$(seen1, id, status, name, qrcode, coordinates, artIndex, time, serializationConstructorMarker) {
    return RealizationCreatedEvent_init_$Init$(seen1, id, status, name, qrcode, coordinates, artIndex, time, serializationConstructorMarker, objectCreate(protoOf(RealizationCreatedEvent)));
  }
  function RealizationCreatedEvent(id, status, name, qrcode, coordinates, artIndex, time) {
    Companion_getInstance_2();
    this.u31_1 = id;
    this.v31_1 = status;
    this.w31_1 = name;
    this.x31_1 = qrcode;
    this.y31_1 = coordinates;
    this.z31_1 = artIndex;
    this.a32_1 = time;
  }
  protoOf(RealizationCreatedEvent).k1y = function () {
    return this.u31_1;
  };
  protoOf(RealizationCreatedEvent).y2f = function () {
    return this.v31_1;
  };
  protoOf(RealizationCreatedEvent).h9 = function () {
    return this.w31_1;
  };
  protoOf(RealizationCreatedEvent).l2c = function () {
    return this.x31_1;
  };
  protoOf(RealizationCreatedEvent).l31 = function () {
    return this.y31_1;
  };
  protoOf(RealizationCreatedEvent).m31 = function () {
    return this.z31_1;
  };
  protoOf(RealizationCreatedEvent).g2c = function () {
    return this.a32_1;
  };
  protoOf(RealizationCreatedEvent).s2Id = function () {
    return this.u31_1;
  };
  protoOf(RealizationCreatedEvent).toString = function () {
    return 'RealizationCreatedEvent(id=' + this.u31_1 + ', status=' + this.v31_1 + ', name=' + this.w31_1 + ', qrcode=' + this.x31_1 + ', coordinates=' + this.y31_1 + ', artIndex=' + this.z31_1 + ', time=' + this.a32_1.toString() + ')';
  };
  protoOf(RealizationCreatedEvent).hashCode = function () {
    var result = getStringHashCode(this.u31_1);
    result = imul(result, 31) + this.v31_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.w31_1) | 0;
    result = imul(result, 31) + (this.x31_1 == null ? 0 : this.x31_1.hashCode()) | 0;
    result = imul(result, 31) + (this.y31_1 == null ? 0 : this.y31_1.hashCode()) | 0;
    result = imul(result, 31) + (this.z31_1 == null ? 0 : getStringHashCode(this.z31_1)) | 0;
    result = imul(result, 31) + this.a32_1.hashCode() | 0;
    return result;
  };
  protoOf(RealizationCreatedEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RealizationCreatedEvent))
      return false;
    var tmp0_other_with_cast = other instanceof RealizationCreatedEvent ? other : THROW_CCE();
    if (!(this.u31_1 === tmp0_other_with_cast.u31_1))
      return false;
    if (!this.v31_1.equals(tmp0_other_with_cast.v31_1))
      return false;
    if (!(this.w31_1 === tmp0_other_with_cast.w31_1))
      return false;
    if (!equals(this.x31_1, tmp0_other_with_cast.x31_1))
      return false;
    if (!equals(this.y31_1, tmp0_other_with_cast.y31_1))
      return false;
    if (!(this.z31_1 == tmp0_other_with_cast.z31_1))
      return false;
    if (!this.a32_1.equals(tmp0_other_with_cast.a32_1))
      return false;
    return true;
  };
  function RealizationDeleteCommandDTO() {
  }
  function RealizationDeletedEventDTO() {
  }
  function Companion_3() {
  }
  var Companion_instance_3;
  function Companion_getInstance_3() {
    return Companion_instance_3;
  }
  function $serializer_2() {
    $serializer_instance_2 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.realization.domain.command.RealizationDeleteCommand', this, 1);
    tmp0_serialDesc.ht('id', false);
    this.b32_1 = tmp0_serialDesc;
  }
  protoOf($serializer_2).ii = function () {
    return this.b32_1;
  };
  protoOf($serializer_2).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  protoOf($serializer_2).ki = function (decoder) {
    var tmp0_desc = this.b32_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.ul(tmp0_desc);
    if (tmp5_input.km()) {
      tmp4_local0 = tmp5_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.vl(tmp0_desc);
    return RealizationDeleteCommand_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_2).c32 = function (encoder, value) {
    var tmp0_desc = this.b32_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.d32_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_2).ji = function (encoder, value) {
    return this.c32(encoder, value instanceof RealizationDeleteCommand ? value : THROW_CCE());
  };
  var $serializer_instance_2;
  function $serializer_getInstance_10() {
    if ($serializer_instance_2 == null)
      new $serializer_2();
    return $serializer_instance_2;
  }
  function RealizationDeleteCommand_init_$Init$(seen1, id, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance_10().b32_1);
    }
    $this.d32_1 = id;
    return $this;
  }
  function RealizationDeleteCommand_init_$Create$(seen1, id, serializationConstructorMarker) {
    return RealizationDeleteCommand_init_$Init$(seen1, id, serializationConstructorMarker, objectCreate(protoOf(RealizationDeleteCommand)));
  }
  function RealizationDeleteCommand(id) {
    this.d32_1 = id;
  }
  protoOf(RealizationDeleteCommand).k1y = function () {
    return this.d32_1;
  };
  protoOf(RealizationDeleteCommand).toString = function () {
    return 'RealizationDeleteCommand(id=' + this.d32_1 + ')';
  };
  protoOf(RealizationDeleteCommand).hashCode = function () {
    return getStringHashCode(this.d32_1);
  };
  protoOf(RealizationDeleteCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RealizationDeleteCommand))
      return false;
    var tmp0_other_with_cast = other instanceof RealizationDeleteCommand ? other : THROW_CCE();
    if (!(this.d32_1 === tmp0_other_with_cast.d32_1))
      return false;
    return true;
  };
  function Companion_4() {
  }
  var Companion_instance_4;
  function Companion_getInstance_4() {
    return Companion_instance_4;
  }
  function $serializer_3() {
    $serializer_instance_3 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RealizationDeletedEvent', this, 2);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('time', false);
    this.e32_1 = tmp0_serialDesc;
  }
  protoOf($serializer_3).ii = function () {
    return this.e32_1;
  };
  protoOf($serializer_3).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), LongSerializer_getInstance()];
  };
  protoOf($serializer_3).ki = function (decoder) {
    var tmp0_desc = this.e32_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = new Long(0, 0);
    var tmp6_input = decoder.ul(tmp0_desc);
    if (tmp6_input.km()) {
      tmp4_local0 = tmp6_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.am(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.am(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.vl(tmp0_desc);
    return RealizationDeletedEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_3).f32 = function (encoder, value) {
    var tmp0_desc = this.e32_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.g32_1);
    tmp1_output.fn(tmp0_desc, 1, value.h32_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_3).ji = function (encoder, value) {
    return this.f32(encoder, value instanceof RealizationDeletedEvent ? value : THROW_CCE());
  };
  var $serializer_instance_3;
  function $serializer_getInstance_11() {
    if ($serializer_instance_3 == null)
      new $serializer_3();
    return $serializer_instance_3;
  }
  function RealizationDeletedEvent_init_$Init$(seen1, id, time, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen1))) {
      throwMissingFieldException(seen1, 3, $serializer_getInstance_11().e32_1);
    }
    $this.g32_1 = id;
    $this.h32_1 = time;
    return $this;
  }
  function RealizationDeletedEvent_init_$Create$(seen1, id, time, serializationConstructorMarker) {
    return RealizationDeletedEvent_init_$Init$(seen1, id, time, serializationConstructorMarker, objectCreate(protoOf(RealizationDeletedEvent)));
  }
  function RealizationDeletedEvent(id, time) {
    this.g32_1 = id;
    this.h32_1 = time;
  }
  protoOf(RealizationDeletedEvent).k1y = function () {
    return this.g32_1;
  };
  protoOf(RealizationDeletedEvent).g2c = function () {
    return this.h32_1;
  };
  protoOf(RealizationDeletedEvent).s2Id = function () {
    return this.g32_1;
  };
  protoOf(RealizationDeletedEvent).toString = function () {
    return 'RealizationDeletedEvent(id=' + this.g32_1 + ', time=' + this.h32_1.toString() + ')';
  };
  protoOf(RealizationDeletedEvent).hashCode = function () {
    var result = getStringHashCode(this.g32_1);
    result = imul(result, 31) + this.h32_1.hashCode() | 0;
    return result;
  };
  protoOf(RealizationDeletedEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RealizationDeletedEvent))
      return false;
    var tmp0_other_with_cast = other instanceof RealizationDeletedEvent ? other : THROW_CCE();
    if (!(this.g32_1 === tmp0_other_with_cast.g32_1))
      return false;
    if (!this.h32_1.equals(tmp0_other_with_cast.h32_1))
      return false;
    return true;
  };
  function RealizationFinishCommandDTO() {
  }
  function RealizationFinishedEventDTO() {
  }
  function Companion_5() {
  }
  var Companion_instance_5;
  function Companion_getInstance_5() {
    return Companion_instance_5;
  }
  function $serializer_4() {
    $serializer_instance_4 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.realization.domain.command.RealizationFinishCommand', this, 1);
    tmp0_serialDesc.ht('id', false);
    this.i32_1 = tmp0_serialDesc;
  }
  protoOf($serializer_4).ii = function () {
    return this.i32_1;
  };
  protoOf($serializer_4).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  protoOf($serializer_4).ki = function (decoder) {
    var tmp0_desc = this.i32_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.ul(tmp0_desc);
    if (tmp5_input.km()) {
      tmp4_local0 = tmp5_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.vl(tmp0_desc);
    return RealizationFinishCommand_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_4).j32 = function (encoder, value) {
    var tmp0_desc = this.i32_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.k32_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_4).ji = function (encoder, value) {
    return this.j32(encoder, value instanceof RealizationFinishCommand ? value : THROW_CCE());
  };
  var $serializer_instance_4;
  function $serializer_getInstance_12() {
    if ($serializer_instance_4 == null)
      new $serializer_4();
    return $serializer_instance_4;
  }
  function RealizationFinishCommand_init_$Init$(seen1, id, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance_12().i32_1);
    }
    $this.k32_1 = id;
    return $this;
  }
  function RealizationFinishCommand_init_$Create$(seen1, id, serializationConstructorMarker) {
    return RealizationFinishCommand_init_$Init$(seen1, id, serializationConstructorMarker, objectCreate(protoOf(RealizationFinishCommand)));
  }
  function RealizationFinishCommand(id) {
    this.k32_1 = id;
  }
  protoOf(RealizationFinishCommand).k1y = function () {
    return this.k32_1;
  };
  protoOf(RealizationFinishCommand).toString = function () {
    return 'RealizationFinishCommand(id=' + this.k32_1 + ')';
  };
  protoOf(RealizationFinishCommand).hashCode = function () {
    return getStringHashCode(this.k32_1);
  };
  protoOf(RealizationFinishCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RealizationFinishCommand))
      return false;
    var tmp0_other_with_cast = other instanceof RealizationFinishCommand ? other : THROW_CCE();
    if (!(this.k32_1 === tmp0_other_with_cast.k32_1))
      return false;
    return true;
  };
  function Companion_6() {
  }
  var Companion_instance_6;
  function Companion_getInstance_6() {
    return Companion_instance_6;
  }
  function $serializer_5() {
    $serializer_instance_5 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RealizationFinishedEvent', this, 2);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('time', false);
    this.l32_1 = tmp0_serialDesc;
  }
  protoOf($serializer_5).ii = function () {
    return this.l32_1;
  };
  protoOf($serializer_5).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), LongSerializer_getInstance()];
  };
  protoOf($serializer_5).ki = function (decoder) {
    var tmp0_desc = this.l32_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = new Long(0, 0);
    var tmp6_input = decoder.ul(tmp0_desc);
    if (tmp6_input.km()) {
      tmp4_local0 = tmp6_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.am(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.am(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.vl(tmp0_desc);
    return RealizationFinishedEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_5).m32 = function (encoder, value) {
    var tmp0_desc = this.l32_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.n32_1);
    tmp1_output.fn(tmp0_desc, 1, value.o32_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_5).ji = function (encoder, value) {
    return this.m32(encoder, value instanceof RealizationFinishedEvent ? value : THROW_CCE());
  };
  var $serializer_instance_5;
  function $serializer_getInstance_13() {
    if ($serializer_instance_5 == null)
      new $serializer_5();
    return $serializer_instance_5;
  }
  function RealizationFinishedEvent_init_$Init$(seen1, id, time, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen1))) {
      throwMissingFieldException(seen1, 3, $serializer_getInstance_13().l32_1);
    }
    $this.n32_1 = id;
    $this.o32_1 = time;
    return $this;
  }
  function RealizationFinishedEvent_init_$Create$(seen1, id, time, serializationConstructorMarker) {
    return RealizationFinishedEvent_init_$Init$(seen1, id, time, serializationConstructorMarker, objectCreate(protoOf(RealizationFinishedEvent)));
  }
  function RealizationFinishedEvent(id, time) {
    this.n32_1 = id;
    this.o32_1 = time;
  }
  protoOf(RealizationFinishedEvent).k1y = function () {
    return this.n32_1;
  };
  protoOf(RealizationFinishedEvent).g2c = function () {
    return this.o32_1;
  };
  protoOf(RealizationFinishedEvent).s2Id = function () {
    return this.n32_1;
  };
  protoOf(RealizationFinishedEvent).toString = function () {
    return 'RealizationFinishedEvent(id=' + this.n32_1 + ', time=' + this.o32_1.toString() + ')';
  };
  protoOf(RealizationFinishedEvent).hashCode = function () {
    var result = getStringHashCode(this.n32_1);
    result = imul(result, 31) + this.o32_1.hashCode() | 0;
    return result;
  };
  protoOf(RealizationFinishedEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RealizationFinishedEvent))
      return false;
    var tmp0_other_with_cast = other instanceof RealizationFinishedEvent ? other : THROW_CCE();
    if (!(this.n32_1 === tmp0_other_with_cast.n32_1))
      return false;
    if (!this.o32_1.equals(tmp0_other_with_cast.o32_1))
      return false;
    return true;
  };
  function RealizationImportCommandDTO() {
  }
  function RealizationImportedEventDTO() {
  }
  function Companion_7() {
  }
  var Companion_instance_7;
  function Companion_getInstance_7() {
    return Companion_instance_7;
  }
  function $serializer_6() {
    $serializer_instance_6 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.realization.domain.command.RealizationImportCommand', this, 1);
    tmp0_serialDesc.ht('item', false);
    this.p32_1 = tmp0_serialDesc;
  }
  protoOf($serializer_6).ii = function () {
    return this.p32_1;
  };
  protoOf($serializer_6).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_22()];
  };
  protoOf($serializer_6).ki = function (decoder) {
    var tmp0_desc = this.p32_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.ul(tmp0_desc);
    if (tmp5_input.km()) {
      tmp4_local0 = tmp5_input.gm(tmp0_desc, 0, $serializer_getInstance_22(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.gm(tmp0_desc, 0, $serializer_getInstance_22(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.vl(tmp0_desc);
    return RealizationImportCommand_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_6).q32 = function (encoder, value) {
    var tmp0_desc = this.p32_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.ln(tmp0_desc, 0, $serializer_getInstance_22(), value.r32_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_6).ji = function (encoder, value) {
    return this.q32(encoder, value instanceof RealizationImportCommand ? value : THROW_CCE());
  };
  var $serializer_instance_6;
  function $serializer_getInstance_14() {
    if ($serializer_instance_6 == null)
      new $serializer_6();
    return $serializer_instance_6;
  }
  function RealizationImportCommand_init_$Init$(seen1, item, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance_14().p32_1);
    }
    $this.r32_1 = item;
    return $this;
  }
  function RealizationImportCommand_init_$Create$(seen1, item, serializationConstructorMarker) {
    return RealizationImportCommand_init_$Init$(seen1, item, serializationConstructorMarker, objectCreate(protoOf(RealizationImportCommand)));
  }
  function RealizationImportCommand(item) {
    this.r32_1 = item;
  }
  protoOf(RealizationImportCommand).q20 = function () {
    return this.r32_1;
  };
  protoOf(RealizationImportCommand).toString = function () {
    return 'RealizationImportCommand(item=' + this.r32_1 + ')';
  };
  protoOf(RealizationImportCommand).hashCode = function () {
    return this.r32_1.hashCode();
  };
  protoOf(RealizationImportCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RealizationImportCommand))
      return false;
    var tmp0_other_with_cast = other instanceof RealizationImportCommand ? other : THROW_CCE();
    if (!this.r32_1.equals(tmp0_other_with_cast.r32_1))
      return false;
    return true;
  };
  function Companion_8() {
  }
  var Companion_instance_8;
  function Companion_getInstance_8() {
    return Companion_instance_8;
  }
  function $serializer_7() {
    $serializer_instance_7 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RealizationImportedEvent', this, 2);
    tmp0_serialDesc.ht('item', false);
    tmp0_serialDesc.ht('time', false);
    this.s32_1 = tmp0_serialDesc;
  }
  protoOf($serializer_7).ii = function () {
    return this.s32_1;
  };
  protoOf($serializer_7).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_22(), LongSerializer_getInstance()];
  };
  protoOf($serializer_7).ki = function (decoder) {
    var tmp0_desc = this.s32_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = new Long(0, 0);
    var tmp6_input = decoder.ul(tmp0_desc);
    if (tmp6_input.km()) {
      tmp4_local0 = tmp6_input.gm(tmp0_desc, 0, $serializer_getInstance_22(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.am(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.gm(tmp0_desc, 0, $serializer_getInstance_22(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.am(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.vl(tmp0_desc);
    return RealizationImportedEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_7).t32 = function (encoder, value) {
    var tmp0_desc = this.s32_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.ln(tmp0_desc, 0, $serializer_getInstance_22(), value.u32_1);
    tmp1_output.fn(tmp0_desc, 1, value.v32_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_7).ji = function (encoder, value) {
    return this.t32(encoder, value instanceof RealizationImportedEvent ? value : THROW_CCE());
  };
  var $serializer_instance_7;
  function $serializer_getInstance_15() {
    if ($serializer_instance_7 == null)
      new $serializer_7();
    return $serializer_instance_7;
  }
  function RealizationImportedEvent_init_$Init$(seen1, item, time, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen1))) {
      throwMissingFieldException(seen1, 3, $serializer_getInstance_15().s32_1);
    }
    $this.u32_1 = item;
    $this.v32_1 = time;
    return $this;
  }
  function RealizationImportedEvent_init_$Create$(seen1, item, time, serializationConstructorMarker) {
    return RealizationImportedEvent_init_$Init$(seen1, item, time, serializationConstructorMarker, objectCreate(protoOf(RealizationImportedEvent)));
  }
  function RealizationImportedEvent(item, time) {
    this.u32_1 = item;
    this.v32_1 = time;
  }
  protoOf(RealizationImportedEvent).q20 = function () {
    return this.u32_1;
  };
  protoOf(RealizationImportedEvent).g2c = function () {
    return this.v32_1;
  };
  protoOf(RealizationImportedEvent).s2Id = function () {
    return this.u32_1.w32_1;
  };
  protoOf(RealizationImportedEvent).toString = function () {
    return 'RealizationImportedEvent(item=' + this.u32_1 + ', time=' + this.v32_1.toString() + ')';
  };
  protoOf(RealizationImportedEvent).hashCode = function () {
    var result = this.u32_1.hashCode();
    result = imul(result, 31) + this.v32_1.hashCode() | 0;
    return result;
  };
  protoOf(RealizationImportedEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RealizationImportedEvent))
      return false;
    var tmp0_other_with_cast = other instanceof RealizationImportedEvent ? other : THROW_CCE();
    if (!this.u32_1.equals(tmp0_other_with_cast.u32_1))
      return false;
    if (!this.v32_1.equals(tmp0_other_with_cast.v32_1))
      return false;
    return true;
  };
  function RealizationRemoveMoeCommandDTO() {
  }
  function RealizationRemovedMoeEventDTO() {
  }
  function RealizationRemoveMoeCommand(id, organization) {
    this.n33_1 = id;
    this.o33_1 = organization;
  }
  protoOf(RealizationRemoveMoeCommand).k1y = function () {
    return this.n33_1;
  };
  protoOf(RealizationRemoveMoeCommand).c2p = function () {
    return this.o33_1;
  };
  protoOf(RealizationRemoveMoeCommand).toString = function () {
    return 'RealizationRemoveMoeCommand(id=' + this.n33_1 + ', organization=' + this.o33_1 + ')';
  };
  protoOf(RealizationRemoveMoeCommand).hashCode = function () {
    var result = getStringHashCode(this.n33_1);
    result = imul(result, 31) + hashCode(this.o33_1) | 0;
    return result;
  };
  protoOf(RealizationRemoveMoeCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RealizationRemoveMoeCommand))
      return false;
    var tmp0_other_with_cast = other instanceof RealizationRemoveMoeCommand ? other : THROW_CCE();
    if (!(this.n33_1 === tmp0_other_with_cast.n33_1))
      return false;
    if (!equals(this.o33_1, tmp0_other_with_cast.o33_1))
      return false;
    return true;
  };
  function Companion_9() {
  }
  var Companion_instance_9;
  function Companion_getInstance_9() {
    return Companion_instance_9;
  }
  function $serializer_8() {
    $serializer_instance_8 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RealizationRemovedMoeEvent', this, 3);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('organizationId', false);
    tmp0_serialDesc.ht('time', false);
    this.p33_1 = tmp0_serialDesc;
  }
  protoOf($serializer_8).ii = function () {
    return this.p33_1;
  };
  protoOf($serializer_8).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance()];
  };
  protoOf($serializer_8).ki = function (decoder) {
    var tmp0_desc = this.p33_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = new Long(0, 0);
    var tmp7_input = decoder.ul(tmp0_desc);
    if (tmp7_input.km()) {
      tmp4_local0 = tmp7_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.em(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.am(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.em(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.am(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.vl(tmp0_desc);
    return RealizationRemovedMoeEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_8).q33 = function (encoder, value) {
    var tmp0_desc = this.p33_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.r33_1);
    tmp1_output.jn(tmp0_desc, 1, value.s33_1);
    tmp1_output.fn(tmp0_desc, 2, value.t33_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_8).ji = function (encoder, value) {
    return this.q33(encoder, value instanceof RealizationRemovedMoeEvent ? value : THROW_CCE());
  };
  var $serializer_instance_8;
  function $serializer_getInstance_16() {
    if ($serializer_instance_8 == null)
      new $serializer_8();
    return $serializer_instance_8;
  }
  function RealizationRemovedMoeEvent_init_$Init$(seen1, id, organizationId, time, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen1))) {
      throwMissingFieldException(seen1, 7, $serializer_getInstance_16().p33_1);
    }
    $this.r33_1 = id;
    $this.s33_1 = organizationId;
    $this.t33_1 = time;
    return $this;
  }
  function RealizationRemovedMoeEvent_init_$Create$(seen1, id, organizationId, time, serializationConstructorMarker) {
    return RealizationRemovedMoeEvent_init_$Init$(seen1, id, organizationId, time, serializationConstructorMarker, objectCreate(protoOf(RealizationRemovedMoeEvent)));
  }
  function RealizationRemovedMoeEvent(id, organizationId, time) {
    this.r33_1 = id;
    this.s33_1 = organizationId;
    this.t33_1 = time;
  }
  protoOf(RealizationRemovedMoeEvent).k1y = function () {
    return this.r33_1;
  };
  protoOf(RealizationRemovedMoeEvent).c2q = function () {
    return this.s33_1;
  };
  protoOf(RealizationRemovedMoeEvent).g2c = function () {
    return this.t33_1;
  };
  protoOf(RealizationRemovedMoeEvent).s2Id = function () {
    return this.r33_1;
  };
  protoOf(RealizationRemovedMoeEvent).toString = function () {
    return 'RealizationRemovedMoeEvent(id=' + this.r33_1 + ', organizationId=' + this.s33_1 + ', time=' + this.t33_1.toString() + ')';
  };
  protoOf(RealizationRemovedMoeEvent).hashCode = function () {
    var result = getStringHashCode(this.r33_1);
    result = imul(result, 31) + getStringHashCode(this.s33_1) | 0;
    result = imul(result, 31) + this.t33_1.hashCode() | 0;
    return result;
  };
  protoOf(RealizationRemovedMoeEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RealizationRemovedMoeEvent))
      return false;
    var tmp0_other_with_cast = other instanceof RealizationRemovedMoeEvent ? other : THROW_CCE();
    if (!(this.r33_1 === tmp0_other_with_cast.r33_1))
      return false;
    if (!(this.s33_1 === tmp0_other_with_cast.s33_1))
      return false;
    if (!this.t33_1.equals(tmp0_other_with_cast.t33_1))
      return false;
    return true;
  };
  function RealizationUnlockCommandDTO() {
  }
  function RealizationUnlockedEventDTO() {
  }
  function Companion_10() {
  }
  var Companion_instance_10;
  function Companion_getInstance_10() {
    return Companion_instance_10;
  }
  function $serializer_9() {
    $serializer_instance_9 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.realization.domain.command.RealizationUnlockCommand', this, 1);
    tmp0_serialDesc.ht('id', false);
    this.u33_1 = tmp0_serialDesc;
  }
  protoOf($serializer_9).ii = function () {
    return this.u33_1;
  };
  protoOf($serializer_9).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  protoOf($serializer_9).ki = function (decoder) {
    var tmp0_desc = this.u33_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.ul(tmp0_desc);
    if (tmp5_input.km()) {
      tmp4_local0 = tmp5_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.vl(tmp0_desc);
    return RealizationUnlockCommand_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_9).v33 = function (encoder, value) {
    var tmp0_desc = this.u33_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.w33_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_9).ji = function (encoder, value) {
    return this.v33(encoder, value instanceof RealizationUnlockCommand ? value : THROW_CCE());
  };
  var $serializer_instance_9;
  function $serializer_getInstance_17() {
    if ($serializer_instance_9 == null)
      new $serializer_9();
    return $serializer_instance_9;
  }
  function RealizationUnlockCommand_init_$Init$(seen1, id, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance_17().u33_1);
    }
    $this.w33_1 = id;
    return $this;
  }
  function RealizationUnlockCommand_init_$Create$(seen1, id, serializationConstructorMarker) {
    return RealizationUnlockCommand_init_$Init$(seen1, id, serializationConstructorMarker, objectCreate(protoOf(RealizationUnlockCommand)));
  }
  function RealizationUnlockCommand(id) {
    this.w33_1 = id;
  }
  protoOf(RealizationUnlockCommand).k1y = function () {
    return this.w33_1;
  };
  protoOf(RealizationUnlockCommand).toString = function () {
    return 'RealizationUnlockCommand(id=' + this.w33_1 + ')';
  };
  protoOf(RealizationUnlockCommand).hashCode = function () {
    return getStringHashCode(this.w33_1);
  };
  protoOf(RealizationUnlockCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RealizationUnlockCommand))
      return false;
    var tmp0_other_with_cast = other instanceof RealizationUnlockCommand ? other : THROW_CCE();
    if (!(this.w33_1 === tmp0_other_with_cast.w33_1))
      return false;
    return true;
  };
  function Companion_11() {
  }
  var Companion_instance_11;
  function Companion_getInstance_11() {
    return Companion_instance_11;
  }
  function $serializer_10() {
    $serializer_instance_10 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RealizationUnlockedEvent', this, 2);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('time', false);
    this.x33_1 = tmp0_serialDesc;
  }
  protoOf($serializer_10).ii = function () {
    return this.x33_1;
  };
  protoOf($serializer_10).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), LongSerializer_getInstance()];
  };
  protoOf($serializer_10).ki = function (decoder) {
    var tmp0_desc = this.x33_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = new Long(0, 0);
    var tmp6_input = decoder.ul(tmp0_desc);
    if (tmp6_input.km()) {
      tmp4_local0 = tmp6_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.am(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.am(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.vl(tmp0_desc);
    return RealizationUnlockedEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_10).y33 = function (encoder, value) {
    var tmp0_desc = this.x33_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.z33_1);
    tmp1_output.fn(tmp0_desc, 1, value.a34_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_10).ji = function (encoder, value) {
    return this.y33(encoder, value instanceof RealizationUnlockedEvent ? value : THROW_CCE());
  };
  var $serializer_instance_10;
  function $serializer_getInstance_18() {
    if ($serializer_instance_10 == null)
      new $serializer_10();
    return $serializer_instance_10;
  }
  function RealizationUnlockedEvent_init_$Init$(seen1, id, time, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen1))) {
      throwMissingFieldException(seen1, 3, $serializer_getInstance_18().x33_1);
    }
    $this.z33_1 = id;
    $this.a34_1 = time;
    return $this;
  }
  function RealizationUnlockedEvent_init_$Create$(seen1, id, time, serializationConstructorMarker) {
    return RealizationUnlockedEvent_init_$Init$(seen1, id, time, serializationConstructorMarker, objectCreate(protoOf(RealizationUnlockedEvent)));
  }
  function RealizationUnlockedEvent(id, time) {
    this.z33_1 = id;
    this.a34_1 = time;
  }
  protoOf(RealizationUnlockedEvent).k1y = function () {
    return this.z33_1;
  };
  protoOf(RealizationUnlockedEvent).g2c = function () {
    return this.a34_1;
  };
  protoOf(RealizationUnlockedEvent).s2Id = function () {
    return this.z33_1;
  };
  protoOf(RealizationUnlockedEvent).toString = function () {
    return 'RealizationUnlockedEvent(id=' + this.z33_1 + ', time=' + this.a34_1.toString() + ')';
  };
  protoOf(RealizationUnlockedEvent).hashCode = function () {
    var result = getStringHashCode(this.z33_1);
    result = imul(result, 31) + this.a34_1.hashCode() | 0;
    return result;
  };
  protoOf(RealizationUnlockedEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RealizationUnlockedEvent))
      return false;
    var tmp0_other_with_cast = other instanceof RealizationUnlockedEvent ? other : THROW_CCE();
    if (!(this.z33_1 === tmp0_other_with_cast.z33_1))
      return false;
    if (!this.a34_1.equals(tmp0_other_with_cast.a34_1))
      return false;
    return true;
  };
  function RealizationUpdateCommandDTO() {
  }
  function RealizationUpdatedEventDTO() {
  }
  function RealizationUpdateCommand(id, name, description, imageCommand, certifications, redirectPath, coordinates, artIndex) {
    this.b34_1 = id;
    this.c34_1 = name;
    this.d34_1 = description;
    this.e34_1 = imageCommand;
    this.f34_1 = certifications;
    this.g34_1 = redirectPath;
    this.h34_1 = coordinates;
    this.i34_1 = artIndex;
  }
  protoOf(RealizationUpdateCommand).k1y = function () {
    return this.b34_1;
  };
  protoOf(RealizationUpdateCommand).h9 = function () {
    return this.c34_1;
  };
  protoOf(RealizationUpdateCommand).w25 = function () {
    return this.d34_1;
  };
  protoOf(RealizationUpdateCommand).n2x = function () {
    return this.e34_1;
  };
  protoOf(RealizationUpdateCommand).h2p = function () {
    return this.f34_1;
  };
  protoOf(RealizationUpdateCommand).h2c = function () {
    return this.g34_1;
  };
  protoOf(RealizationUpdateCommand).l31 = function () {
    return this.h34_1;
  };
  protoOf(RealizationUpdateCommand).m31 = function () {
    return this.i34_1;
  };
  protoOf(RealizationUpdateCommand).toString = function () {
    return 'RealizationUpdateCommand(id=' + this.b34_1 + ', name=' + this.c34_1 + ', description=' + this.d34_1 + ', imageCommand=' + this.e34_1 + ', certifications=' + this.f34_1 + ', redirectPath=' + this.g34_1 + ', coordinates=' + this.h34_1 + ', artIndex=' + this.i34_1 + ')';
  };
  protoOf(RealizationUpdateCommand).hashCode = function () {
    var result = getStringHashCode(this.b34_1);
    result = imul(result, 31) + getStringHashCode(this.c34_1) | 0;
    result = imul(result, 31) + (this.d34_1 == null ? 0 : getStringHashCode(this.d34_1)) | 0;
    result = imul(result, 31) + (this.e34_1 == null ? 0 : this.e34_1.hashCode()) | 0;
    result = imul(result, 31) + (this.f34_1 == null ? 0 : hashCode(this.f34_1)) | 0;
    result = imul(result, 31) + (this.g34_1 == null ? 0 : getStringHashCode(this.g34_1)) | 0;
    result = imul(result, 31) + (this.h34_1 == null ? 0 : this.h34_1.hashCode()) | 0;
    result = imul(result, 31) + (this.i34_1 == null ? 0 : getStringHashCode(this.i34_1)) | 0;
    return result;
  };
  protoOf(RealizationUpdateCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RealizationUpdateCommand))
      return false;
    var tmp0_other_with_cast = other instanceof RealizationUpdateCommand ? other : THROW_CCE();
    if (!(this.b34_1 === tmp0_other_with_cast.b34_1))
      return false;
    if (!(this.c34_1 === tmp0_other_with_cast.c34_1))
      return false;
    if (!(this.d34_1 == tmp0_other_with_cast.d34_1))
      return false;
    if (!equals(this.e34_1, tmp0_other_with_cast.e34_1))
      return false;
    if (!equals(this.f34_1, tmp0_other_with_cast.f34_1))
      return false;
    if (!(this.g34_1 == tmp0_other_with_cast.g34_1))
      return false;
    if (!equals(this.h34_1, tmp0_other_with_cast.h34_1))
      return false;
    if (!(this.i34_1 == tmp0_other_with_cast.i34_1))
      return false;
    return true;
  };
  function Companion_12() {
    Companion_instance_12 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.j34_1 = [null, null, new ArrayListSerializer($serializer_getInstance_21()), null, null, Companion_getInstance().x14(), null, null, null, null];
  }
  var Companion_instance_12;
  function Companion_getInstance_12() {
    if (Companion_instance_12 == null)
      new Companion_12();
    return Companion_instance_12;
  }
  function $serializer_11() {
    $serializer_instance_11 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RealizationUpdatedEvent', this, 10);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('name', false);
    tmp0_serialDesc.ht('certifications', false);
    tmp0_serialDesc.ht('description', false);
    tmp0_serialDesc.ht('cover', false);
    tmp0_serialDesc.ht('status', false);
    tmp0_serialDesc.ht('coordinates', false);
    tmp0_serialDesc.ht('artIndex', false);
    tmp0_serialDesc.ht('qrcode', false);
    tmp0_serialDesc.ht('time', false);
    this.k34_1 = tmp0_serialDesc;
  }
  protoOf($serializer_11).ii = function () {
    return this.k34_1;
  };
  protoOf($serializer_11).wt = function () {
    var tmp0_cached = Companion_getInstance_12().j34_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(tmp0_cached[2]), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), tmp0_cached[5], get_nullable($serializer_getInstance_1()), get_nullable(StringSerializer_getInstance()), get_nullable($serializer_getInstance_0()), LongSerializer_getInstance()];
  };
  protoOf($serializer_11).ki = function (decoder) {
    var tmp0_desc = this.k34_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = new Long(0, 0);
    var tmp14_input = decoder.ul(tmp0_desc);
    var tmp15_cached = Companion_getInstance_12().j34_1;
    if (tmp14_input.km()) {
      tmp4_local0 = tmp14_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp14_input.em(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp14_input.im(tmp0_desc, 2, tmp15_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp14_input.im(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp14_input.im(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp14_input.gm(tmp0_desc, 5, tmp15_cached[5], tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp14_input.im(tmp0_desc, 6, $serializer_getInstance_1(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp14_input.im(tmp0_desc, 7, StringSerializer_getInstance(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp14_input.im(tmp0_desc, 8, $serializer_getInstance_0(), tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp14_input.am(tmp0_desc, 9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp14_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp14_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp14_input.em(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp14_input.im(tmp0_desc, 2, tmp15_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp14_input.im(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp14_input.im(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp14_input.gm(tmp0_desc, 5, tmp15_cached[5], tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp14_input.im(tmp0_desc, 6, $serializer_getInstance_1(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp14_input.im(tmp0_desc, 7, StringSerializer_getInstance(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp14_input.im(tmp0_desc, 8, $serializer_getInstance_0(), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp14_input.am(tmp0_desc, 9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp14_input.vl(tmp0_desc);
    return RealizationUpdatedEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, null);
  };
  protoOf($serializer_11).l34 = function (encoder, value) {
    var tmp0_desc = this.k34_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    var tmp2_cached = Companion_getInstance_12().j34_1;
    tmp1_output.jn(tmp0_desc, 0, value.m34_1);
    tmp1_output.jn(tmp0_desc, 1, value.n34_1);
    tmp1_output.nn(tmp0_desc, 2, tmp2_cached[2], value.o34_1);
    tmp1_output.nn(tmp0_desc, 3, StringSerializer_getInstance(), value.p34_1);
    tmp1_output.nn(tmp0_desc, 4, StringSerializer_getInstance(), value.q34_1);
    tmp1_output.ln(tmp0_desc, 5, tmp2_cached[5], value.r34_1);
    tmp1_output.nn(tmp0_desc, 6, $serializer_getInstance_1(), value.s34_1);
    tmp1_output.nn(tmp0_desc, 7, StringSerializer_getInstance(), value.t34_1);
    tmp1_output.nn(tmp0_desc, 8, $serializer_getInstance_0(), value.u34_1);
    tmp1_output.fn(tmp0_desc, 9, value.v34_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_11).ji = function (encoder, value) {
    return this.l34(encoder, value instanceof RealizationUpdatedEvent ? value : THROW_CCE());
  };
  var $serializer_instance_11;
  function $serializer_getInstance_19() {
    if ($serializer_instance_11 == null)
      new $serializer_11();
    return $serializer_instance_11;
  }
  function RealizationUpdatedEvent_init_$Init$(seen1, id, name, certifications, description, cover, status, coordinates, artIndex, qrcode, time, serializationConstructorMarker, $this) {
    if (!(1023 === (1023 & seen1))) {
      throwMissingFieldException(seen1, 1023, $serializer_getInstance_19().k34_1);
    }
    $this.m34_1 = id;
    $this.n34_1 = name;
    $this.o34_1 = certifications;
    $this.p34_1 = description;
    $this.q34_1 = cover;
    $this.r34_1 = status;
    $this.s34_1 = coordinates;
    $this.t34_1 = artIndex;
    $this.u34_1 = qrcode;
    $this.v34_1 = time;
    return $this;
  }
  function RealizationUpdatedEvent_init_$Create$(seen1, id, name, certifications, description, cover, status, coordinates, artIndex, qrcode, time, serializationConstructorMarker) {
    return RealizationUpdatedEvent_init_$Init$(seen1, id, name, certifications, description, cover, status, coordinates, artIndex, qrcode, time, serializationConstructorMarker, objectCreate(protoOf(RealizationUpdatedEvent)));
  }
  function RealizationUpdatedEvent(id, name, certifications, description, cover, status, coordinates, artIndex, qrcode, time) {
    Companion_getInstance_12();
    this.m34_1 = id;
    this.n34_1 = name;
    this.o34_1 = certifications;
    this.p34_1 = description;
    this.q34_1 = cover;
    this.r34_1 = status;
    this.s34_1 = coordinates;
    this.t34_1 = artIndex;
    this.u34_1 = qrcode;
    this.v34_1 = time;
  }
  protoOf(RealizationUpdatedEvent).k1y = function () {
    return this.m34_1;
  };
  protoOf(RealizationUpdatedEvent).h9 = function () {
    return this.n34_1;
  };
  protoOf(RealizationUpdatedEvent).h2p = function () {
    return this.o34_1;
  };
  protoOf(RealizationUpdatedEvent).w25 = function () {
    return this.p34_1;
  };
  protoOf(RealizationUpdatedEvent).p2x = function () {
    return this.q34_1;
  };
  protoOf(RealizationUpdatedEvent).y2f = function () {
    return this.r34_1;
  };
  protoOf(RealizationUpdatedEvent).l31 = function () {
    return this.s34_1;
  };
  protoOf(RealizationUpdatedEvent).m31 = function () {
    return this.t34_1;
  };
  protoOf(RealizationUpdatedEvent).l2c = function () {
    return this.u34_1;
  };
  protoOf(RealizationUpdatedEvent).g2c = function () {
    return this.v34_1;
  };
  protoOf(RealizationUpdatedEvent).s2Id = function () {
    return this.m34_1;
  };
  protoOf(RealizationUpdatedEvent).toString = function () {
    return 'RealizationUpdatedEvent(id=' + this.m34_1 + ', name=' + this.n34_1 + ', certifications=' + this.o34_1 + ', description=' + this.p34_1 + ', cover=' + this.q34_1 + ', status=' + this.r34_1 + ', coordinates=' + this.s34_1 + ', artIndex=' + this.t34_1 + ', qrcode=' + this.u34_1 + ', time=' + this.v34_1.toString() + ')';
  };
  protoOf(RealizationUpdatedEvent).hashCode = function () {
    var result = getStringHashCode(this.m34_1);
    result = imul(result, 31) + getStringHashCode(this.n34_1) | 0;
    result = imul(result, 31) + (this.o34_1 == null ? 0 : hashCode(this.o34_1)) | 0;
    result = imul(result, 31) + (this.p34_1 == null ? 0 : getStringHashCode(this.p34_1)) | 0;
    result = imul(result, 31) + (this.q34_1 == null ? 0 : getStringHashCode(this.q34_1)) | 0;
    result = imul(result, 31) + this.r34_1.hashCode() | 0;
    result = imul(result, 31) + (this.s34_1 == null ? 0 : this.s34_1.hashCode()) | 0;
    result = imul(result, 31) + (this.t34_1 == null ? 0 : getStringHashCode(this.t34_1)) | 0;
    result = imul(result, 31) + (this.u34_1 == null ? 0 : this.u34_1.hashCode()) | 0;
    result = imul(result, 31) + this.v34_1.hashCode() | 0;
    return result;
  };
  protoOf(RealizationUpdatedEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RealizationUpdatedEvent))
      return false;
    var tmp0_other_with_cast = other instanceof RealizationUpdatedEvent ? other : THROW_CCE();
    if (!(this.m34_1 === tmp0_other_with_cast.m34_1))
      return false;
    if (!(this.n34_1 === tmp0_other_with_cast.n34_1))
      return false;
    if (!equals(this.o34_1, tmp0_other_with_cast.o34_1))
      return false;
    if (!(this.p34_1 == tmp0_other_with_cast.p34_1))
      return false;
    if (!(this.q34_1 == tmp0_other_with_cast.q34_1))
      return false;
    if (!this.r34_1.equals(tmp0_other_with_cast.r34_1))
      return false;
    if (!equals(this.s34_1, tmp0_other_with_cast.s34_1))
      return false;
    if (!(this.t34_1 == tmp0_other_with_cast.t34_1))
      return false;
    if (!equals(this.u34_1, tmp0_other_with_cast.u34_1))
      return false;
    if (!this.v34_1.equals(tmp0_other_with_cast.v34_1))
      return false;
    return true;
  };
  function RealizationCertificationIdLinkDTO() {
  }
  function RealizationCertificationLinkDTO() {
  }
  function $serializer_12() {
    $serializer_instance_12 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.realization.domain.model.RealizationCertificationLink', this, 2);
    tmp0_serialDesc.ht('model', false);
    tmp0_serialDesc.ht('url', false);
    this.x34_1 = tmp0_serialDesc;
  }
  protoOf($serializer_12).ii = function () {
    return this.x34_1;
  };
  protoOf($serializer_12).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_2(), get_nullable(StringSerializer_getInstance())];
  };
  protoOf($serializer_12).ki = function (decoder) {
    var tmp0_desc = this.x34_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.ul(tmp0_desc);
    if (tmp6_input.km()) {
      tmp4_local0 = tmp6_input.gm(tmp0_desc, 0, $serializer_getInstance_2(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.im(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.gm(tmp0_desc, 0, $serializer_getInstance_2(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.im(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.vl(tmp0_desc);
    return RealizationCertificationLink_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_12).y34 = function (encoder, value) {
    var tmp0_desc = this.x34_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.ln(tmp0_desc, 0, $serializer_getInstance_2(), value.z34_1);
    tmp1_output.nn(tmp0_desc, 1, StringSerializer_getInstance(), value.a35_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_12).ji = function (encoder, value) {
    return this.y34(encoder, value instanceof RealizationCertificationLink ? value : THROW_CCE());
  };
  var $serializer_instance_12;
  function $serializer_getInstance_20() {
    if ($serializer_instance_12 == null)
      new $serializer_12();
    return $serializer_instance_12;
  }
  function RealizationCertificationLink_init_$Init$(seen1, model, url, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen1))) {
      throwMissingFieldException(seen1, 3, $serializer_getInstance_20().x34_1);
    }
    $this.z34_1 = model;
    $this.a35_1 = url;
    return $this;
  }
  function RealizationCertificationLink_init_$Create$(seen1, model, url, serializationConstructorMarker) {
    return RealizationCertificationLink_init_$Init$(seen1, model, url, serializationConstructorMarker, objectCreate(protoOf(RealizationCertificationLink)));
  }
  function RealizationCertificationLink() {
  }
  protoOf(RealizationCertificationLink).w34 = function () {
    return this.z34_1;
  };
  protoOf(RealizationCertificationLink).v21 = function () {
    return this.a35_1;
  };
  protoOf(RealizationCertificationLink).toString = function () {
    return 'RealizationCertificationLink(model=' + this.z34_1 + ', url=' + this.a35_1 + ')';
  };
  protoOf(RealizationCertificationLink).hashCode = function () {
    var result = this.z34_1.hashCode();
    result = imul(result, 31) + (this.a35_1 == null ? 0 : getStringHashCode(this.a35_1)) | 0;
    return result;
  };
  protoOf(RealizationCertificationLink).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RealizationCertificationLink))
      return false;
    var tmp0_other_with_cast = other instanceof RealizationCertificationLink ? other : THROW_CCE();
    if (!this.z34_1.equals(tmp0_other_with_cast.z34_1))
      return false;
    if (!(this.a35_1 == tmp0_other_with_cast.a35_1))
      return false;
    return true;
  };
  function $serializer_13() {
    $serializer_instance_13 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.realization.domain.model.RealizationCertificationIdLink', this, 2);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('url', false);
    this.b35_1 = tmp0_serialDesc;
  }
  protoOf($serializer_13).ii = function () {
    return this.b35_1;
  };
  protoOf($serializer_13).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
  };
  protoOf($serializer_13).ki = function (decoder) {
    var tmp0_desc = this.b35_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.ul(tmp0_desc);
    if (tmp6_input.km()) {
      tmp4_local0 = tmp6_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.im(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.im(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.vl(tmp0_desc);
    return RealizationCertificationIdLink_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_13).c35 = function (encoder, value) {
    var tmp0_desc = this.b35_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.d35_1);
    tmp1_output.nn(tmp0_desc, 1, StringSerializer_getInstance(), value.e35_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_13).ji = function (encoder, value) {
    return this.c35(encoder, value instanceof RealizationCertificationIdLink ? value : THROW_CCE());
  };
  var $serializer_instance_13;
  function $serializer_getInstance_21() {
    if ($serializer_instance_13 == null)
      new $serializer_13();
    return $serializer_instance_13;
  }
  function RealizationCertificationIdLink_init_$Init$(seen1, id, url, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen1))) {
      throwMissingFieldException(seen1, 3, $serializer_getInstance_21().b35_1);
    }
    $this.d35_1 = id;
    $this.e35_1 = url;
    return $this;
  }
  function RealizationCertificationIdLink_init_$Create$(seen1, id, url, serializationConstructorMarker) {
    return RealizationCertificationIdLink_init_$Init$(seen1, id, url, serializationConstructorMarker, objectCreate(protoOf(RealizationCertificationIdLink)));
  }
  function RealizationCertificationIdLink() {
  }
  protoOf(RealizationCertificationIdLink).k1y = function () {
    return this.d35_1;
  };
  protoOf(RealizationCertificationIdLink).v21 = function () {
    return this.e35_1;
  };
  protoOf(RealizationCertificationIdLink).toString = function () {
    return 'RealizationCertificationIdLink(id=' + this.d35_1 + ', url=' + this.e35_1 + ')';
  };
  protoOf(RealizationCertificationIdLink).hashCode = function () {
    var result = getStringHashCode(this.d35_1);
    result = imul(result, 31) + (this.e35_1 == null ? 0 : getStringHashCode(this.e35_1)) | 0;
    return result;
  };
  protoOf(RealizationCertificationIdLink).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RealizationCertificationIdLink))
      return false;
    var tmp0_other_with_cast = other instanceof RealizationCertificationIdLink ? other : THROW_CCE();
    if (!(this.d35_1 === tmp0_other_with_cast.d35_1))
      return false;
    if (!(this.e35_1 == tmp0_other_with_cast.e35_1))
      return false;
    return true;
  };
  function RealizationModelDTO() {
  }
  function TransformationActorDTO() {
  }
  function Companion_13() {
    Companion_instance_13 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.l35_1 = [null, new ArrayListSerializer($serializer_getInstance_3()), Companion_getInstance().x14(), null, null, null, new ArrayListSerializer($serializer_getInstance_23()), new ArrayListSerializer($serializer_getInstance_4()), new ArrayListSerializer($serializer_getInstance_5()), new ArrayListSerializer($serializer_getInstance_6()), new ArrayListSerializer($serializer_getInstance_20()), null, null, null, null, null, null];
  }
  var Companion_instance_13;
  function Companion_getInstance_13() {
    if (Companion_instance_13 == null)
      new Companion_13();
    return Companion_instance_13;
  }
  function $serializer_14() {
    $serializer_instance_14 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.realization.domain.model.RealizationModel', this, 17);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('moes', false);
    tmp0_serialDesc.ht('status', false);
    tmp0_serialDesc.ht('name', false);
    tmp0_serialDesc.ht('description', false);
    tmp0_serialDesc.ht('cover', false);
    tmp0_serialDesc.ht('actors', false);
    tmp0_serialDesc.ht('ouvrages', false);
    tmp0_serialDesc.ht('species', false);
    tmp0_serialDesc.ht('removalZones', false);
    tmp0_serialDesc.ht('certifications', true);
    tmp0_serialDesc.ht('qrcode', false);
    tmp0_serialDesc.ht('coordinates', false);
    tmp0_serialDesc.ht('creationDate', false);
    tmp0_serialDesc.ht('updateDate', false);
    tmp0_serialDesc.ht('validationDate', false);
    tmp0_serialDesc.ht('artIndex', false);
    this.m35_1 = tmp0_serialDesc;
  }
  protoOf($serializer_14).ii = function () {
    return this.m35_1;
  };
  protoOf($serializer_14).wt = function () {
    var tmp0_cached = Companion_getInstance_13().l35_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), tmp0_cached[1], tmp0_cached[2], StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), tmp0_cached[6], tmp0_cached[7], tmp0_cached[8], tmp0_cached[9], tmp0_cached[10], get_nullable($serializer_getInstance_0()), get_nullable($serializer_getInstance_1()), LongSerializer_getInstance(), LongSerializer_getInstance(), get_nullable(LongSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  protoOf($serializer_14).ki = function (decoder) {
    var tmp0_desc = this.m35_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_local10 = null;
    var tmp15_local11 = null;
    var tmp16_local12 = null;
    var tmp17_local13 = new Long(0, 0);
    var tmp18_local14 = new Long(0, 0);
    var tmp19_local15 = null;
    var tmp20_local16 = null;
    var tmp21_input = decoder.ul(tmp0_desc);
    var tmp22_cached = Companion_getInstance_13().l35_1;
    if (tmp21_input.km()) {
      tmp4_local0 = tmp21_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp21_input.gm(tmp0_desc, 1, tmp22_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp21_input.gm(tmp0_desc, 2, tmp22_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp21_input.em(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp21_input.im(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp21_input.im(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp21_input.gm(tmp0_desc, 6, tmp22_cached[6], tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp21_input.gm(tmp0_desc, 7, tmp22_cached[7], tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp21_input.gm(tmp0_desc, 8, tmp22_cached[8], tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp21_input.gm(tmp0_desc, 9, tmp22_cached[9], tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp21_input.gm(tmp0_desc, 10, tmp22_cached[10], tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp21_input.im(tmp0_desc, 11, $serializer_getInstance_0(), tmp15_local11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp21_input.im(tmp0_desc, 12, $serializer_getInstance_1(), tmp16_local12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
      tmp17_local13 = tmp21_input.am(tmp0_desc, 13);
      tmp3_bitMask0 = tmp3_bitMask0 | 8192;
      tmp18_local14 = tmp21_input.am(tmp0_desc, 14);
      tmp3_bitMask0 = tmp3_bitMask0 | 16384;
      tmp19_local15 = tmp21_input.im(tmp0_desc, 15, LongSerializer_getInstance(), tmp19_local15);
      tmp3_bitMask0 = tmp3_bitMask0 | 32768;
      tmp20_local16 = tmp21_input.im(tmp0_desc, 16, StringSerializer_getInstance(), tmp20_local16);
      tmp3_bitMask0 = tmp3_bitMask0 | 65536;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp21_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp21_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp21_input.gm(tmp0_desc, 1, tmp22_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp21_input.gm(tmp0_desc, 2, tmp22_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp21_input.em(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp21_input.im(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp21_input.im(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp21_input.gm(tmp0_desc, 6, tmp22_cached[6], tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp21_input.gm(tmp0_desc, 7, tmp22_cached[7], tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp21_input.gm(tmp0_desc, 8, tmp22_cached[8], tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp21_input.gm(tmp0_desc, 9, tmp22_cached[9], tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp21_input.gm(tmp0_desc, 10, tmp22_cached[10], tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp21_input.im(tmp0_desc, 11, $serializer_getInstance_0(), tmp15_local11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp21_input.im(tmp0_desc, 12, $serializer_getInstance_1(), tmp16_local12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          case 13:
            tmp17_local13 = tmp21_input.am(tmp0_desc, 13);
            tmp3_bitMask0 = tmp3_bitMask0 | 8192;
            break;
          case 14:
            tmp18_local14 = tmp21_input.am(tmp0_desc, 14);
            tmp3_bitMask0 = tmp3_bitMask0 | 16384;
            break;
          case 15:
            tmp19_local15 = tmp21_input.im(tmp0_desc, 15, LongSerializer_getInstance(), tmp19_local15);
            tmp3_bitMask0 = tmp3_bitMask0 | 32768;
            break;
          case 16:
            tmp20_local16 = tmp21_input.im(tmp0_desc, 16, StringSerializer_getInstance(), tmp20_local16);
            tmp3_bitMask0 = tmp3_bitMask0 | 65536;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp21_input.vl(tmp0_desc);
    return RealizationModel_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, tmp20_local16, null);
  };
  protoOf($serializer_14).n35 = function (encoder, value) {
    var tmp0_desc = this.m35_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    var tmp2_cached = Companion_getInstance_13().l35_1;
    tmp1_output.jn(tmp0_desc, 0, value.w32_1);
    tmp1_output.ln(tmp0_desc, 1, tmp2_cached[1], value.x32_1);
    tmp1_output.ln(tmp0_desc, 2, tmp2_cached[2], value.y32_1);
    tmp1_output.jn(tmp0_desc, 3, value.z32_1);
    tmp1_output.nn(tmp0_desc, 4, StringSerializer_getInstance(), value.a33_1);
    tmp1_output.nn(tmp0_desc, 5, StringSerializer_getInstance(), value.b33_1);
    tmp1_output.ln(tmp0_desc, 6, tmp2_cached[6], value.c33_1);
    tmp1_output.ln(tmp0_desc, 7, tmp2_cached[7], value.d33_1);
    tmp1_output.ln(tmp0_desc, 8, tmp2_cached[8], value.e33_1);
    tmp1_output.ln(tmp0_desc, 9, tmp2_cached[9], value.f33_1);
    if (tmp1_output.rn(tmp0_desc, 10) ? true : !equals(value.g33_1, emptyList())) {
      tmp1_output.ln(tmp0_desc, 10, tmp2_cached[10], value.g33_1);
    }
    tmp1_output.nn(tmp0_desc, 11, $serializer_getInstance_0(), value.h33_1);
    tmp1_output.nn(tmp0_desc, 12, $serializer_getInstance_1(), value.i33_1);
    tmp1_output.fn(tmp0_desc, 13, value.j33_1);
    tmp1_output.fn(tmp0_desc, 14, value.k33_1);
    tmp1_output.nn(tmp0_desc, 15, LongSerializer_getInstance(), value.l33_1);
    tmp1_output.nn(tmp0_desc, 16, StringSerializer_getInstance(), value.m33_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_14).ji = function (encoder, value) {
    return this.n35(encoder, value instanceof RealizationModel ? value : THROW_CCE());
  };
  var $serializer_instance_14;
  function $serializer_getInstance_22() {
    if ($serializer_instance_14 == null)
      new $serializer_14();
    return $serializer_instance_14;
  }
  function RealizationModel_init_$Init$(seen1, id, moes, status, name, description, cover, actors, ouvrages, species, removalZones, certifications, qrcode, coordinates, creationDate, updateDate, validationDate, artIndex, serializationConstructorMarker, $this) {
    if (!(130047 === (130047 & seen1))) {
      throwMissingFieldException(seen1, 130047, $serializer_getInstance_22().m35_1);
    }
    $this.w32_1 = id;
    $this.x32_1 = moes;
    $this.y32_1 = status;
    $this.z32_1 = name;
    $this.a33_1 = description;
    $this.b33_1 = cover;
    $this.c33_1 = actors;
    $this.d33_1 = ouvrages;
    $this.e33_1 = species;
    $this.f33_1 = removalZones;
    if (0 === (seen1 & 1024))
      $this.g33_1 = emptyList();
    else
      $this.g33_1 = certifications;
    $this.h33_1 = qrcode;
    $this.i33_1 = coordinates;
    $this.j33_1 = creationDate;
    $this.k33_1 = updateDate;
    $this.l33_1 = validationDate;
    $this.m33_1 = artIndex;
    return $this;
  }
  function RealizationModel_init_$Create$(seen1, id, moes, status, name, description, cover, actors, ouvrages, species, removalZones, certifications, qrcode, coordinates, creationDate, updateDate, validationDate, artIndex, serializationConstructorMarker) {
    return RealizationModel_init_$Init$(seen1, id, moes, status, name, description, cover, actors, ouvrages, species, removalZones, certifications, qrcode, coordinates, creationDate, updateDate, validationDate, artIndex, serializationConstructorMarker, objectCreate(protoOf(RealizationModel)));
  }
  function RealizationModel() {
  }
  protoOf(RealizationModel).k1y = function () {
    return this.w32_1;
  };
  protoOf(RealizationModel).f35 = function () {
    return this.x32_1;
  };
  protoOf(RealizationModel).y2f = function () {
    return this.y32_1;
  };
  protoOf(RealizationModel).h9 = function () {
    return this.z32_1;
  };
  protoOf(RealizationModel).w25 = function () {
    return this.a33_1;
  };
  protoOf(RealizationModel).p2x = function () {
    return this.b33_1;
  };
  protoOf(RealizationModel).g35 = function () {
    return this.c33_1;
  };
  protoOf(RealizationModel).h35 = function () {
    return this.d33_1;
  };
  protoOf(RealizationModel).s2v = function () {
    return this.e33_1;
  };
  protoOf(RealizationModel).z2x = function () {
    return this.f33_1;
  };
  protoOf(RealizationModel).h2p = function () {
    return this.g33_1;
  };
  protoOf(RealizationModel).l2c = function () {
    return this.h33_1;
  };
  protoOf(RealizationModel).l31 = function () {
    return this.i33_1;
  };
  protoOf(RealizationModel).v2h = function () {
    return this.j33_1;
  };
  protoOf(RealizationModel).i35 = function () {
    return this.k33_1;
  };
  protoOf(RealizationModel).j35 = function () {
    return this.l33_1;
  };
  protoOf(RealizationModel).m31 = function () {
    return this.m33_1;
  };
  protoOf(RealizationModel).s2State = function () {
    return this.y32_1;
  };
  protoOf(RealizationModel).s2Id = function () {
    return this.w32_1;
  };
  protoOf(RealizationModel).toString = function () {
    return 'RealizationModel(id=' + this.w32_1 + ', moes=' + this.x32_1 + ', status=' + this.y32_1 + ', name=' + this.z32_1 + ', description=' + this.a33_1 + ', cover=' + this.b33_1 + ', actors=' + this.c33_1 + ', ouvrages=' + this.d33_1 + ', species=' + this.e33_1 + ', removalZones=' + this.f33_1 + ', certifications=' + this.g33_1 + ', qrcode=' + this.h33_1 + ', coordinates=' + this.i33_1 + ', creationDate=' + this.j33_1.toString() + ', updateDate=' + this.k33_1.toString() + ', validationDate=' + toString(this.l33_1) + ', artIndex=' + this.m33_1 + ')';
  };
  protoOf(RealizationModel).hashCode = function () {
    var result = getStringHashCode(this.w32_1);
    result = imul(result, 31) + hashCode(this.x32_1) | 0;
    result = imul(result, 31) + this.y32_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.z32_1) | 0;
    result = imul(result, 31) + (this.a33_1 == null ? 0 : getStringHashCode(this.a33_1)) | 0;
    result = imul(result, 31) + (this.b33_1 == null ? 0 : getStringHashCode(this.b33_1)) | 0;
    result = imul(result, 31) + hashCode(this.c33_1) | 0;
    result = imul(result, 31) + hashCode(this.d33_1) | 0;
    result = imul(result, 31) + hashCode(this.e33_1) | 0;
    result = imul(result, 31) + hashCode(this.f33_1) | 0;
    result = imul(result, 31) + hashCode(this.g33_1) | 0;
    result = imul(result, 31) + (this.h33_1 == null ? 0 : this.h33_1.hashCode()) | 0;
    result = imul(result, 31) + (this.i33_1 == null ? 0 : this.i33_1.hashCode()) | 0;
    result = imul(result, 31) + this.j33_1.hashCode() | 0;
    result = imul(result, 31) + this.k33_1.hashCode() | 0;
    result = imul(result, 31) + (this.l33_1 == null ? 0 : this.l33_1.hashCode()) | 0;
    result = imul(result, 31) + (this.m33_1 == null ? 0 : getStringHashCode(this.m33_1)) | 0;
    return result;
  };
  protoOf(RealizationModel).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RealizationModel))
      return false;
    var tmp0_other_with_cast = other instanceof RealizationModel ? other : THROW_CCE();
    if (!(this.w32_1 === tmp0_other_with_cast.w32_1))
      return false;
    if (!equals(this.x32_1, tmp0_other_with_cast.x32_1))
      return false;
    if (!this.y32_1.equals(tmp0_other_with_cast.y32_1))
      return false;
    if (!(this.z32_1 === tmp0_other_with_cast.z32_1))
      return false;
    if (!(this.a33_1 == tmp0_other_with_cast.a33_1))
      return false;
    if (!(this.b33_1 == tmp0_other_with_cast.b33_1))
      return false;
    if (!equals(this.c33_1, tmp0_other_with_cast.c33_1))
      return false;
    if (!equals(this.d33_1, tmp0_other_with_cast.d33_1))
      return false;
    if (!equals(this.e33_1, tmp0_other_with_cast.e33_1))
      return false;
    if (!equals(this.f33_1, tmp0_other_with_cast.f33_1))
      return false;
    if (!equals(this.g33_1, tmp0_other_with_cast.g33_1))
      return false;
    if (!equals(this.h33_1, tmp0_other_with_cast.h33_1))
      return false;
    if (!equals(this.i33_1, tmp0_other_with_cast.i33_1))
      return false;
    if (!this.j33_1.equals(tmp0_other_with_cast.j33_1))
      return false;
    if (!this.k33_1.equals(tmp0_other_with_cast.k33_1))
      return false;
    if (!equals(this.l33_1, tmp0_other_with_cast.l33_1))
      return false;
    if (!(this.m33_1 == tmp0_other_with_cast.m33_1))
      return false;
    return true;
  };
  function Companion_14() {
    Companion_instance_14 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.o35_1 = [null, new ArrayListSerializer(StringSerializer_getInstance())];
  }
  var Companion_instance_14;
  function Companion_getInstance_14() {
    if (Companion_instance_14 == null)
      new Companion_14();
    return Companion_instance_14;
  }
  function $serializer_15() {
    $serializer_instance_15 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.realization.domain.model.TransformationActor', this, 2);
    tmp0_serialDesc.ht('organizationRef', false);
    tmp0_serialDesc.ht('product', false);
    this.p35_1 = tmp0_serialDesc;
  }
  protoOf($serializer_15).ii = function () {
    return this.p35_1;
  };
  protoOf($serializer_15).wt = function () {
    var tmp0_cached = Companion_getInstance_14().o35_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable($serializer_getInstance_3()), tmp0_cached[1]];
  };
  protoOf($serializer_15).ki = function (decoder) {
    var tmp0_desc = this.p35_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.ul(tmp0_desc);
    var tmp7_cached = Companion_getInstance_14().o35_1;
    if (tmp6_input.km()) {
      tmp4_local0 = tmp6_input.im(tmp0_desc, 0, $serializer_getInstance_3(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.gm(tmp0_desc, 1, tmp7_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.im(tmp0_desc, 0, $serializer_getInstance_3(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.gm(tmp0_desc, 1, tmp7_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.vl(tmp0_desc);
    return TransformationActor_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_15).q35 = function (encoder, value) {
    var tmp0_desc = this.p35_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    var tmp2_cached = Companion_getInstance_14().o35_1;
    tmp1_output.nn(tmp0_desc, 0, $serializer_getInstance_3(), value.r35_1);
    tmp1_output.ln(tmp0_desc, 1, tmp2_cached[1], value.s35_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_15).ji = function (encoder, value) {
    return this.q35(encoder, value instanceof TransformationActor ? value : THROW_CCE());
  };
  var $serializer_instance_15;
  function $serializer_getInstance_23() {
    if ($serializer_instance_15 == null)
      new $serializer_15();
    return $serializer_instance_15;
  }
  function TransformationActor_init_$Init$(seen1, organizationRef, product, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen1))) {
      throwMissingFieldException(seen1, 3, $serializer_getInstance_23().p35_1);
    }
    $this.r35_1 = organizationRef;
    $this.s35_1 = product;
    return $this;
  }
  function TransformationActor_init_$Create$(seen1, organizationRef, product, serializationConstructorMarker) {
    return TransformationActor_init_$Init$(seen1, organizationRef, product, serializationConstructorMarker, objectCreate(protoOf(TransformationActor)));
  }
  function TransformationActor() {
  }
  protoOf(TransformationActor).k35 = function () {
    return this.r35_1;
  };
  protoOf(TransformationActor).q2u = function () {
    return this.s35_1;
  };
  protoOf(TransformationActor).toString = function () {
    return 'TransformationActor(organizationRef=' + this.r35_1 + ', product=' + this.s35_1 + ')';
  };
  protoOf(TransformationActor).hashCode = function () {
    var result = this.r35_1 == null ? 0 : this.r35_1.hashCode();
    result = imul(result, 31) + hashCode(this.s35_1) | 0;
    return result;
  };
  protoOf(TransformationActor).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TransformationActor))
      return false;
    var tmp0_other_with_cast = other instanceof TransformationActor ? other : THROW_CCE();
    if (!equals(this.r35_1, tmp0_other_with_cast.r35_1))
      return false;
    if (!equals(this.s35_1, tmp0_other_with_cast.s35_1))
      return false;
    return true;
  };
  function RealizationRefDTO() {
  }
  function RealizationModelGetQueryDTO() {
  }
  function RealizationModelGetResponseDTO() {
  }
  function RealizationModelPageFiltersDTO() {
  }
  function RealizationModelPageQueryDTO() {
  }
  function RealizationModelPageResponseDTO() {
  }
  //region block: post-declaration
  defineProp(protoOf(RealizationState), 'position', function () {
    return this.jr();
  }, function (value) {
    this.y2c(value);
  });
  defineProp(protoOf(RealizationState), 'name', protoOf(RealizationState).h9);
  defineProp(protoOf(RealizationState), 'ordinal', protoOf(RealizationState).i9);
  protoOf($serializer).xt = typeParametersSerializers;
  defineProp(protoOf(RealizationAssignMoeCommand), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(RealizationAssignMoeCommand), 'organization', function () {
    return this.c2p();
  });
  defineProp(protoOf(RealizationAssignMoeCommand), 'organizationName', function () {
    return this.w30();
  });
  defineProp(protoOf(RealizationAssignMoeCommand), 'organizationType', function () {
    return this.x30();
  });
  defineProp(protoOf(RealizationAssignMoeCommand), 'siret', function () {
    return this.y30();
  });
  protoOf($serializer_0).xt = typeParametersSerializers;
  defineProp(protoOf(RealizationAssignedMoeEvent), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(RealizationAssignedMoeEvent), 'status', function () {
    return this.y2f();
  });
  defineProp(protoOf(RealizationAssignedMoeEvent), 'organization', function () {
    return this.c2p();
  });
  defineProp(protoOf(RealizationAssignedMoeEvent), 'time');
  defineProp(protoOf(RealizationCreateCommand), 'name', function () {
    return this.h9();
  });
  defineProp(protoOf(RealizationCreateCommand), 'coordinates', function () {
    return this.l31();
  });
  defineProp(protoOf(RealizationCreateCommand), 'redirectPath', function () {
    return this.h2c();
  });
  defineProp(protoOf(RealizationCreateCommand), 'artIndex', function () {
    return this.m31();
  });
  protoOf($serializer_1).xt = typeParametersSerializers;
  defineProp(protoOf(RealizationCreatedEvent), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(RealizationCreatedEvent), 'status', function () {
    return this.y2f();
  });
  defineProp(protoOf(RealizationCreatedEvent), 'name', function () {
    return this.h9();
  });
  defineProp(protoOf(RealizationCreatedEvent), 'qrcode', function () {
    return this.l2c();
  });
  defineProp(protoOf(RealizationCreatedEvent), 'coordinates', function () {
    return this.l31();
  });
  defineProp(protoOf(RealizationCreatedEvent), 'artIndex', function () {
    return this.m31();
  });
  defineProp(protoOf(RealizationCreatedEvent), 'time');
  protoOf($serializer_2).xt = typeParametersSerializers;
  defineProp(protoOf(RealizationDeleteCommand), 'id', function () {
    return this.k1y();
  });
  protoOf($serializer_3).xt = typeParametersSerializers;
  defineProp(protoOf(RealizationDeletedEvent), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(RealizationDeletedEvent), 'time');
  protoOf($serializer_4).xt = typeParametersSerializers;
  defineProp(protoOf(RealizationFinishCommand), 'id', function () {
    return this.k1y();
  });
  protoOf($serializer_5).xt = typeParametersSerializers;
  defineProp(protoOf(RealizationFinishedEvent), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(RealizationFinishedEvent), 'time');
  protoOf($serializer_6).xt = typeParametersSerializers;
  defineProp(protoOf(RealizationImportCommand), 'item', function () {
    return this.q20();
  });
  protoOf($serializer_7).xt = typeParametersSerializers;
  defineProp(protoOf(RealizationImportedEvent), 'item', function () {
    return this.q20();
  });
  defineProp(protoOf(RealizationImportedEvent), 'time');
  defineProp(protoOf(RealizationRemoveMoeCommand), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(RealizationRemoveMoeCommand), 'organization', function () {
    return this.c2p();
  });
  protoOf($serializer_8).xt = typeParametersSerializers;
  defineProp(protoOf(RealizationRemovedMoeEvent), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(RealizationRemovedMoeEvent), 'organizationId', function () {
    return this.c2q();
  });
  defineProp(protoOf(RealizationRemovedMoeEvent), 'time');
  protoOf($serializer_9).xt = typeParametersSerializers;
  defineProp(protoOf(RealizationUnlockCommand), 'id', function () {
    return this.k1y();
  });
  protoOf($serializer_10).xt = typeParametersSerializers;
  defineProp(protoOf(RealizationUnlockedEvent), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(RealizationUnlockedEvent), 'time');
  defineProp(protoOf(RealizationUpdateCommand), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(RealizationUpdateCommand), 'name', function () {
    return this.h9();
  });
  defineProp(protoOf(RealizationUpdateCommand), 'description', function () {
    return this.w25();
  });
  defineProp(protoOf(RealizationUpdateCommand), 'imageCommand', function () {
    return this.n2x();
  });
  defineProp(protoOf(RealizationUpdateCommand), 'certifications', function () {
    return this.h2p();
  });
  defineProp(protoOf(RealizationUpdateCommand), 'redirectPath', function () {
    return this.h2c();
  });
  defineProp(protoOf(RealizationUpdateCommand), 'coordinates', function () {
    return this.l31();
  });
  defineProp(protoOf(RealizationUpdateCommand), 'artIndex', function () {
    return this.m31();
  });
  protoOf($serializer_11).xt = typeParametersSerializers;
  defineProp(protoOf(RealizationUpdatedEvent), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(RealizationUpdatedEvent), 'name', function () {
    return this.h9();
  });
  defineProp(protoOf(RealizationUpdatedEvent), 'certifications', function () {
    return this.h2p();
  });
  defineProp(protoOf(RealizationUpdatedEvent), 'description', function () {
    return this.w25();
  });
  defineProp(protoOf(RealizationUpdatedEvent), 'cover', function () {
    return this.p2x();
  });
  defineProp(protoOf(RealizationUpdatedEvent), 'status', function () {
    return this.y2f();
  });
  defineProp(protoOf(RealizationUpdatedEvent), 'coordinates', function () {
    return this.l31();
  });
  defineProp(protoOf(RealizationUpdatedEvent), 'artIndex', function () {
    return this.m31();
  });
  defineProp(protoOf(RealizationUpdatedEvent), 'qrcode', function () {
    return this.l2c();
  });
  defineProp(protoOf(RealizationUpdatedEvent), 'time');
  protoOf($serializer_12).xt = typeParametersSerializers;
  defineProp(protoOf(RealizationCertificationLink), 'model', function () {
    return this.w34();
  });
  defineProp(protoOf(RealizationCertificationLink), 'url', function () {
    return this.v21();
  });
  protoOf($serializer_13).xt = typeParametersSerializers;
  defineProp(protoOf(RealizationCertificationIdLink), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(RealizationCertificationIdLink), 'url', function () {
    return this.v21();
  });
  protoOf($serializer_14).xt = typeParametersSerializers;
  defineProp(protoOf(RealizationModel), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(RealizationModel), 'moes', function () {
    return this.f35();
  });
  defineProp(protoOf(RealizationModel), 'status', function () {
    return this.y2f();
  });
  defineProp(protoOf(RealizationModel), 'name', function () {
    return this.h9();
  });
  defineProp(protoOf(RealizationModel), 'description', function () {
    return this.w25();
  });
  defineProp(protoOf(RealizationModel), 'cover', function () {
    return this.p2x();
  });
  defineProp(protoOf(RealizationModel), 'actors', function () {
    return this.g35();
  });
  defineProp(protoOf(RealizationModel), 'ouvrages', function () {
    return this.h35();
  });
  defineProp(protoOf(RealizationModel), 'species', function () {
    return this.s2v();
  });
  defineProp(protoOf(RealizationModel), 'removalZones', function () {
    return this.z2x();
  });
  defineProp(protoOf(RealizationModel), 'certifications', function () {
    return this.h2p();
  });
  defineProp(protoOf(RealizationModel), 'qrcode', function () {
    return this.l2c();
  });
  defineProp(protoOf(RealizationModel), 'coordinates', function () {
    return this.l31();
  });
  defineProp(protoOf(RealizationModel), 'creationDate', function () {
    return this.v2h();
  });
  defineProp(protoOf(RealizationModel), 'updateDate', function () {
    return this.i35();
  });
  defineProp(protoOf(RealizationModel), 'validationDate', function () {
    return this.j35();
  });
  defineProp(protoOf(RealizationModel), 'artIndex', function () {
    return this.m31();
  });
  protoOf($serializer_15).xt = typeParametersSerializers;
  defineProp(protoOf(TransformationActor), 'organizationRef', function () {
    return this.k35();
  });
  defineProp(protoOf(TransformationActor), 'product', function () {
    return this.q2u();
  });
  //endregion
  //region block: init
  Companion_instance_0 = new Companion_0();
  Companion_instance_3 = new Companion_3();
  Companion_instance_4 = new Companion_4();
  Companion_instance_5 = new Companion_5();
  Companion_instance_6 = new Companion_6();
  Companion_instance_7 = new Companion_7();
  Companion_instance_8 = new Companion_8();
  Companion_instance_9 = new Companion_9();
  Companion_instance_10 = new Companion_10();
  Companion_instance_11 = new Companion_11();
  //endregion
  //region block: exports
  function $jsExportAll$(_) {
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$realization = $org$boislocal$platform$s2.realization || ($org$boislocal$platform$s2.realization = {});
    var $org$boislocal$platform$s2$realization$domain = $org$boislocal$platform$s2$realization.domain || ($org$boislocal$platform$s2$realization.domain = {});
    var $org$boislocal$platform$s2$realization$domain$automate = $org$boislocal$platform$s2$realization$domain.automate || ($org$boislocal$platform$s2$realization$domain.automate = {});
    $org$boislocal$platform$s2$realization$domain$automate.RealizationState = RealizationState;
    $org$boislocal$platform$s2$realization$domain$automate.RealizationState.values = values;
    $org$boislocal$platform$s2$realization$domain$automate.RealizationState.valueOf = valueOf;
    defineProp($org$boislocal$platform$s2$realization$domain$automate.RealizationState, 'Exists', RealizationState_Exists_getInstance);
    defineProp($org$boislocal$platform$s2$realization$domain$automate.RealizationState, 'Deleted', RealizationState_Deleted_getInstance);
    defineProp($org$boislocal$platform$s2$realization$domain$automate.RealizationState, 'Finished', RealizationState_Finished_getInstance);
    defineProp($org$boislocal$platform$s2$realization$domain$automate.RealizationState, 'Companion', Companion_getInstance);
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$realization = $org$boislocal$platform$s2.realization || ($org$boislocal$platform$s2.realization = {});
    var $org$boislocal$platform$s2$realization$domain = $org$boislocal$platform$s2$realization.domain || ($org$boislocal$platform$s2$realization.domain = {});
    var $org$boislocal$platform$s2$realization$domain$command = $org$boislocal$platform$s2$realization$domain.command || ($org$boislocal$platform$s2$realization$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$realization = $org$boislocal$platform$s2.realization || ($org$boislocal$platform$s2.realization = {});
    var $org$boislocal$platform$s2$realization$domain = $org$boislocal$platform$s2$realization.domain || ($org$boislocal$platform$s2$realization.domain = {});
    var $org$boislocal$platform$s2$realization$domain$command = $org$boislocal$platform$s2$realization$domain.command || ($org$boislocal$platform$s2$realization$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$realization = $org$boislocal$platform$s2.realization || ($org$boislocal$platform$s2.realization = {});
    var $org$boislocal$platform$s2$realization$domain = $org$boislocal$platform$s2$realization.domain || ($org$boislocal$platform$s2$realization.domain = {});
    var $org$boislocal$platform$s2$realization$domain$command = $org$boislocal$platform$s2$realization$domain.command || ($org$boislocal$platform$s2$realization$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$realization = $org$boislocal$platform$s2.realization || ($org$boislocal$platform$s2.realization = {});
    var $org$boislocal$platform$s2$realization$domain = $org$boislocal$platform$s2$realization.domain || ($org$boislocal$platform$s2$realization.domain = {});
    var $org$boislocal$platform$s2$realization$domain$command = $org$boislocal$platform$s2$realization$domain.command || ($org$boislocal$platform$s2$realization$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$realization = $org$boislocal$platform$s2.realization || ($org$boislocal$platform$s2.realization = {});
    var $org$boislocal$platform$s2$realization$domain = $org$boislocal$platform$s2$realization.domain || ($org$boislocal$platform$s2$realization.domain = {});
    var $org$boislocal$platform$s2$realization$domain$command = $org$boislocal$platform$s2$realization$domain.command || ($org$boislocal$platform$s2$realization$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$realization = $org$boislocal$platform$s2.realization || ($org$boislocal$platform$s2.realization = {});
    var $org$boislocal$platform$s2$realization$domain = $org$boislocal$platform$s2$realization.domain || ($org$boislocal$platform$s2$realization.domain = {});
    var $org$boislocal$platform$s2$realization$domain$command = $org$boislocal$platform$s2$realization$domain.command || ($org$boislocal$platform$s2$realization$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$realization = $org$boislocal$platform$s2.realization || ($org$boislocal$platform$s2.realization = {});
    var $org$boislocal$platform$s2$realization$domain = $org$boislocal$platform$s2$realization.domain || ($org$boislocal$platform$s2$realization.domain = {});
    var $org$boislocal$platform$s2$realization$domain$command = $org$boislocal$platform$s2$realization$domain.command || ($org$boislocal$platform$s2$realization$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$realization = $org$boislocal$platform$s2.realization || ($org$boislocal$platform$s2.realization = {});
    var $org$boislocal$platform$s2$realization$domain = $org$boislocal$platform$s2$realization.domain || ($org$boislocal$platform$s2$realization.domain = {});
    var $org$boislocal$platform$s2$realization$domain$command = $org$boislocal$platform$s2$realization$domain.command || ($org$boislocal$platform$s2$realization$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$realization = $org$boislocal$platform$s2.realization || ($org$boislocal$platform$s2.realization = {});
    var $org$boislocal$platform$s2$realization$domain = $org$boislocal$platform$s2$realization.domain || ($org$boislocal$platform$s2$realization.domain = {});
    var $org$boislocal$platform$s2$realization$domain$model = $org$boislocal$platform$s2$realization$domain.model || ($org$boislocal$platform$s2$realization$domain.model = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$realization = $org$boislocal$platform$s2.realization || ($org$boislocal$platform$s2.realization = {});
    var $org$boislocal$platform$s2$realization$domain = $org$boislocal$platform$s2$realization.domain || ($org$boislocal$platform$s2$realization.domain = {});
    var $org$boislocal$platform$s2$realization$domain$model = $org$boislocal$platform$s2$realization$domain.model || ($org$boislocal$platform$s2$realization$domain.model = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$realization = $org$boislocal$platform$s2.realization || ($org$boislocal$platform$s2.realization = {});
    var $org$boislocal$platform$s2$realization$domain = $org$boislocal$platform$s2$realization.domain || ($org$boislocal$platform$s2$realization.domain = {});
    var $org$boislocal$platform$s2$realization$domain$model = $org$boislocal$platform$s2$realization$domain.model || ($org$boislocal$platform$s2$realization$domain.model = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$realization = $org$boislocal$platform$s2.realization || ($org$boislocal$platform$s2.realization = {});
    var $org$boislocal$platform$s2$realization$domain = $org$boislocal$platform$s2$realization.domain || ($org$boislocal$platform$s2$realization.domain = {});
    var $org$boislocal$platform$s2$realization$domain$query = $org$boislocal$platform$s2$realization$domain.query || ($org$boislocal$platform$s2$realization$domain.query = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$realization = $org$boislocal$platform$s2.realization || ($org$boislocal$platform$s2.realization = {});
    var $org$boislocal$platform$s2$realization$domain = $org$boislocal$platform$s2$realization.domain || ($org$boislocal$platform$s2$realization.domain = {});
    var $org$boislocal$platform$s2$realization$domain$query = $org$boislocal$platform$s2$realization$domain.query || ($org$boislocal$platform$s2$realization$domain.query = {});
  }
  $jsExportAll$(_);
  _.$jsExportAll$ = $jsExportAll$;
  _.$_$ = _.$_$ || {};
  _.$_$.a = S2_getInstance;
  _.$_$.b = RealizationDeleteCommand;
  _.$_$.c = RealizationFinishCommand;
  _.$_$.d = RealizationUnlockCommand;
  _.$_$.e = RealizationUpdateCommand;
  //endregion
  return _;
}));

//# sourceMappingURL=boislocal-platform-platform-s2-realization-realization-domain.js.map
